var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_9_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 251.12,
    cy: 350.431,
    rx: 208.38,
    ry: 122.419
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_12_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M67.121,385.681c6.426,5.534,28.382,18.273,38.073,21.981 c9.691,3.707,15.64,2.237,22.847-0.04c7.207-2.277,14.809-6.451,20.709-9.723c9.81-5.44,25.77-13.719,16.641-18.515l-37.915-21.891 c-6.315-3.646-37.577,1.832-43.892,5.479c0,0-12.868,5.377-17.835,9.128C60.783,375.853,60.198,379.72,67.121,385.681z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_11_",
    style: {
      fill: "#E0E0E0"
    },
    points: "264.943,452.781 136.848,378.825 308.275,280.26 436.37,354.216  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_10_",
    style: {
      fill: "#E0E0E0"
    },
    cx: 168.8,
    cy: 317.818,
    rx: 74.154,
    ry: 41.058
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_9_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M211.939,461.854l44.196-25.516c0.632-0.365,0.632-0.956,0-1.32l-69.226-39.967 c-0.632-0.365-1.655-0.365-2.287,0l-44.197,25.517c-0.632,0.365-0.632,0.956,0,1.32l69.226,39.967 C210.283,462.219,211.307,462.219,211.939,461.854z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_745_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5311_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5312_",
    style: {
      fill: "#263238"
    },
    d: "M170.624,353.982c-0.875,0-1.583-0.708-1.583-1.583V250.655 c0-0.875,0.708-1.583,1.583-1.583c0.875,0,1.583,0.708,1.583,1.583v101.743C172.206,353.274,171.498,353.982,170.624,353.982z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5309_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5310_",
    style: {
      fill: "#263238"
    },
    d: "M233.573,316.948c-0.63,0-1.226-0.379-1.471-1.002l-31.199-78.967 c-0.321-0.813,0.077-1.733,0.89-2.052c0.81-0.325,1.731,0.076,2.052,0.89l31.199,78.967c0.322,0.813-0.077,1.732-0.89,2.052 C233.964,316.913,233.766,316.948,233.573,316.948z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5307_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5308_",
    style: {
      fill: "#263238"
    },
    d: "M229.826,307.463c-0.42,0-0.839-0.167-1.15-0.496l-58.054-61.432 l-57.949,61.173c-0.601,0.637-1.603,0.663-2.236,0.06c-0.635-0.601-0.662-1.603-0.06-2.236l59.098-62.387 c0.298-0.315,0.714-0.495,1.148-0.495h0.002c0.434,0,0.85,0.179,1.148,0.496l59.202,62.648c0.601,0.635,0.572,1.637-0.063,2.236 C230.606,307.319,230.217,307.463,229.826,307.463z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5305_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5306_",
    style: {
      fill: "#263238"
    },
    d: "M107.675,316.948c-0.193,0-0.391-0.036-0.581-0.111 c-0.813-0.32-1.212-1.239-0.89-2.052l31.199-78.967c0.321-0.815,1.241-1.215,2.052-0.89c0.813,0.32,1.212,1.239,0.89,2.052 l-31.199,78.967C108.901,316.57,108.306,316.948,107.675,316.948z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5303_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5304_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M231.423,305.024l4.125,10.885c0.025,0.093,0.037,0.185,0.037,0.278 c0.006,0.062,0.006,0.13,0,0.198c-0.037,0.223-0.318,0.507-0.621,0.686c-0.693,0.402-1.818,0.402-2.511,0 c-0.254-0.148-0.414-0.328-0.489-0.513c0-0.006,0-0.012-0.006-0.018l-0.031-0.148l-3.824-10.205L231.423,305.024z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5302_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M109.826,305.024l-4.125,10.885c-0.025,0.093-0.037,0.185-0.037,0.278 c-0.006,0.062-0.006,0.13,0,0.198c0.037,0.223,0.318,0.507,0.622,0.686c0.692,0.402,1.818,0.402,2.51,0 c0.254-0.148,0.414-0.328,0.489-0.513c0-0.006,0-0.012,0.006-0.018l0.031-0.148l3.824-10.205L109.826,305.024z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2135_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3228_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M172.449,344.521l0,9.004c0,0.269-0.178,0.539-0.535,0.745 c-0.713,0.411-1.868,0.411-2.58,0c-0.356-0.206-0.534-0.475-0.534-0.745v-9.004 C170.016,343.911,171.232,343.911,172.449,344.521z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_744_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M230.19,240.682c-0.005-2.384-2.093-4.927-6.512-7.794 c-8.166-5.298-26.41-15.931-37.835-22.262c-0.023-0.085-0.096-0.094-0.096-0.094c-8.792-5.336-16.992-30.746-23.078-50.057 c-2.074-6.581-4.614-10.306-7.625-12.055c-0.715-0.415-3.349-1.867-3.938-2.22c-5.97-3.578-13.807,0.72-23.569,6.063 c-8.993,4.922-16.017,11.222-17.431,27.939c-0.86,10.179-0.041,29.631,2.026,44.372c-0.001-0.002-0.006-0.013-0.006-0.013 c2.993,24.628,6.668,24.671,12.001,28.792c9.18,7.092,29.857,17.063,38.569,20.49c15.806,6.217,28.721-3.369,38.347-8.123 c9.626-4.754,21.459-12.17,25.51-15.113c2.41-1.75,3.656-3.518,3.631-5.384C230.175,244.486,230.192,241.454,230.19,240.682z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_728_",
    style: {
      opacity: 0.25
    },
    d: "M230.19,240.682c-0.005-2.384-2.093-4.927-6.512-7.794 c-8.166-5.298-26.41-15.931-37.835-22.262c-0.023-0.085-0.096-0.094-0.096-0.094c-8.792-5.336-16.992-30.746-23.078-50.057 c-2.074-6.581-4.614-10.306-7.625-12.055c-0.715-0.415-3.349-1.867-3.938-2.22c-5.97-3.578-13.807,0.72-23.569,6.063 c-8.993,4.922-16.017,11.222-17.431,27.939c-0.86,10.179-0.041,29.631,2.026,44.372c-0.001-0.002-0.006-0.013-0.006-0.013 c2.993,24.628,6.668,24.671,12.001,28.792c9.18,7.092,29.857,17.063,38.569,20.49c15.806,6.217,28.721-3.369,38.347-8.123 c9.626-4.754,21.459-12.17,25.51-15.113c2.41-1.75,3.656-3.518,3.631-5.384C230.175,244.486,230.192,241.454,230.19,240.682z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M154.694,148.219c-5.916-3.105-13.604,1.117-23.114,6.327 c-6.092,3.339-11.283,7.296-14.436,14.7l-4.015-2.321c3.154-7.375,8.335-11.332,14.407-14.661 c9.764-5.348,17.599-9.637,23.574-6.062C151.628,146.506,153.704,147.661,154.694,148.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M223.678,232.888c-5.296-3.436-5.415-4.314-38.097-22.428c0.087,0.024,0.133,0.05,0.153,0.063 c-8.787-5.353-16.982-30.747-23.065-50.048c-6.178-19.605-16.482-13.923-31.092-5.926c-8.993,4.922-16.017,11.222-17.431,27.94 c-1.408,16.656,1.675,58.163,7.379,63.176c6.224,6.883,31.195,19.673,41.171,23.598c15.806,6.217,28.721-3.369,38.348-8.123 c9.626-4.754,21.459-12.17,25.51-15.113C232.032,242.05,231.527,237.98,223.678,232.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M185.734,210.524c0.004,0.003,0.009,0.006,0.013,0.009 C185.747,210.532,185.742,210.529,185.734,210.524z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_473_",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_475_",
    d: "M131.577,154.549c14.61-7.996,24.914-13.678,31.092,5.926c6.086,19.311,14.286,44.721,23.078,50.057 c0,0-15.077-0.011-36.928,11.788c-22.719,12.268-26.189,24.267-27.231,23.403c-5.745-4.763-8.855-46.517-7.442-63.235 C115.56,165.772,122.584,159.471,131.577,154.549z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5430_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M228.034,211.934c-5.816,2.3-10.341,2.939-15.135-4.224 c-6.041-9.028-23.102-51.449-23.102-51.449l10.676-16.524c9.488,2.921,10.847,6.472,15.973,21.294 c5.141,14.866,9.494,29.591,9.494,29.591"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M199.87,139.463c0,0,4.794,0.273,8.42,3.444c3.33,2.912,4.326,4.959,8.155,14.979 c3.83,10.019,7.832,21.72,7.832,21.72s-9.043,9.513-20.991,11.604c-0.25-1.141-7.641-40.544-7.641-40.544L199.87,139.463z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5444_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5453_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5456_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M234.108,330.83c0,0,2.693,15.854,7.483,21.662 c4.317,5.234,7.488,11.962,12.593,17.399c1.112,1.184,3.623,3.366,4.532,4.324c0.809,0.853,0.976,1.869-0.082,2.966 c-2.084,2.162-11.256,3.028-16.565-0.623c-5.309-3.652-10.664-10.794-13.863-13.776c-1.601-1.493-3.106-2.921-4.21-3.974 c-1.059-1.011-1.515-2.495-1.197-3.925c0.09-0.405,0.19-0.881,0.299-1.438c0.586-2.997-3.829-15.023-3.829-15.023 L234.108,330.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M223.732,362.008c0,0,0.028,1.719,0.574,2.848c0.546,1.129,3.241,2.76,4.948,3.514 c1.708,0.754,3.737,2.073,5.464,5.406c1.846,3.561,5.385,6.944,9.27,8.531c3.886,1.587,9.58,2.503,16.329,0.991 c6.749-1.511,7.131-5.544,7.131-5.544s0.198-3.787-1.52-4.31C264.21,372.919,223.732,362.008,223.732,362.008z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5455_",
    style: {
      fill: "#455A64"
    },
    d: "M221.595,345.44c0.891,4.128,0.794,7.636,0.685,9.769 c-0.102,1.981-0.073,5.098,1.452,6.798c2.121,2.693,6.461,3.414,9.355,7.09c2.894,3.676,7.213,10.361,16.195,11.751 c8.983,1.391,15.621-1.726,17.16-4.331c1.539-2.604-0.066-4.93-5.905-7.77c-6.199-3.015-14.59-12.427-14.59-12.427 c-2.237-2.813-4.504-5.579-5.982-9.455L237.632,340c-0.509-1.336-10.059,1.782-11.034,3.729l1.299,6.109l-2.603-5.741 C223.316,344.108,222.874,344.799,221.595,345.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M243.422,378.968c0,0-0.386-6.231,6.185-9.95c6.571-3.719,10.745-1.678,12.862-0.286 c2.522,1.658,6.178,5.186,4.166,7.947c-2.174,2.982-5.79,4.509-12.639,4.881C247.148,381.931,243.422,378.968,243.422,378.968 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M233.339,358.537c0.236-0.018,0.462-0.138,0.597-0.345c0.718-1.095,5.436-5.276,10.212-4.161 c0.219-0.555-0.202-1.101-1.196-1.641c-4.977-0.234-9.458,3.698-10.324,5.02c-0.227,0.346-0.117,0.802,0.243,1.017 C233.016,358.514,233.179,358.548,233.339,358.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M247.003,357.466c-0.106-0.709-0.9-1.444-1.407-1.585c-4.719,0.102-8.873,3.771-9.705,5.037 c-0.227,0.346-0.117,0.801,0.243,1.017c0.146,0.088,0.309,0.122,0.469,0.11c0.237-0.018,0.462-0.138,0.597-0.344 C237.898,360.637,242.377,356.677,247.003,357.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M241.939,350.853c0.215-0.85-0.035-1.5-1.005-1.82c-5.457-1.057-10.635,3.439-11.571,4.871 c-0.227,0.345-0.118,0.801,0.245,1.015c0.145,0.088,0.308,0.122,0.467,0.11c0.236-0.017,0.462-0.138,0.596-0.346 C231.443,353.508,236.834,348.772,241.939,350.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M254.736,364.799c-0.43-0.818-1.171-1.45-2.193-1.895c-4.892-0.116-9.268,3.727-10.123,5.03 c-0.227,0.346-0.117,0.802,0.243,1.017c0.146,0.087,0.309,0.122,0.469,0.11c0.236-0.018,0.462-0.138,0.597-0.345 C244.487,367.562,249.701,362.973,254.736,364.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M239.868,365.553c0.236-0.018,0.462-0.138,0.597-0.345c0.71-1.082,5.334-5.172,10.052-4.191 c-0.204-0.689-0.749-1.245-1.656-1.629c-4.721,0.102-8.875,3.771-9.705,5.038c-0.227,0.346-0.117,0.802,0.243,1.017 C239.545,365.531,239.708,365.565,239.868,365.553z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5454_",
    style: {
      fill: "#37474F"
    },
    d: "M133.05,217.525c-2.315,12.266-2.334,18.29,1.847,26.932 c4.298,8.884,17.611,16.269,30.389,24.002c11.842,7.166,24.603,14.952,27.547,16.827c3.17,2.02,4.816,3.194,5.583,8.351 c0.899,6.042,3.984,15.684,10.674,28.198c7.636,14.283,10.634,21.444,10.634,21.444s9.307-3.288,16.387-6.448 c0,0-14.063-58.43-17.091-66.271c-3.028-7.841-33.979-32.347-33.979-32.347s2.683-12.724,4.68-21.986L133.05,217.525z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5446_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5452_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M273.699,316.035c0,0,4.515,12.933,8.031,18.954 c3.36,5.753,7.353,11.747,12.367,17.086c1.092,1.163,3.558,3.306,4.45,4.246c0.794,0.837,0.958,1.835-0.081,2.912 c-2.046,2.123-11.054,2.974-16.267-0.612c-5.213-3.586-10.472-10.599-13.613-13.529c-1.572-1.466-3.05-2.868-4.134-3.902 c-1.04-0.993-1.488-2.451-1.175-3.854c0.089-0.398,0.186-0.865,0.293-1.412c0.575-2.944-3.76-14.753-3.76-14.753 L273.699,316.035z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5451_",
    style: {
      fill: "#37474F"
    },
    d: "M177.347,201.922c-1.433,9.268-1.822,14.503,1.638,23.745 c3.46,9.242,11.362,23.88,24.557,30.876c10.92,5.79,25.103,12.894,28.147,14.602c2.727,1.531,4.888,3.574,6.089,10.236 c1.085,6.012,4.403,12.816,11.668,25.004c7.674,12.874,10.65,19.928,10.65,19.928c4.904-2.342,11.282-5.123,15.949-6.26 c0,0-16.796-57.382-19.824-65.222c-3.028-7.841-23.902-19.001-32.866-23.897c-8.964-4.897-13.979-7.958-24.228-14.567 L177.347,201.922z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M264.063,344.27c0,0,0.028,1.688,0.564,2.796c0.536,1.108,3.182,2.71,4.859,3.451 c1.677,0.741,3.669,2.036,5.366,5.308c1.813,3.497,5.288,6.819,9.104,8.377c3.816,1.559,9.407,2.458,16.035,0.974 c6.628-1.484,7.002-5.444,7.002-5.444s0.194-3.719-1.493-4.233C303.813,354.985,264.063,344.27,264.063,344.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5450_",
    style: {
      fill: "#455A64"
    },
    d: "M261.964,328c0.875,4.053,0.78,7.499,0.672,9.593 c-0.099,1.946-0.071,5.006,1.426,6.676c2.083,2.644,6.345,3.353,9.186,6.962c2.842,3.609,7.083,10.174,15.904,11.54 c8.821,1.366,15.34-1.695,16.851-4.253c1.511-2.558-0.065-4.841-5.799-7.63c-6.088-2.961-14.328-12.203-14.328-12.203 c-2.196-2.763-4.422-5.479-5.874-9.285l-1.926-6.368c-0.5-1.312-10.047,1.369-11.004,3.282l1.314,5.83l-2.76-5.436 L261.964,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M283.399,360.925c0,0-0.378-6.119,6.074-9.771c6.452-3.652,10.551-1.648,12.631-0.281 c2.477,1.628,6.067,5.093,4.091,7.804c-2.135,2.928-5.686,4.428-12.411,4.793 C287.058,363.835,283.399,360.925,283.399,360.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M273.497,340.861c0.232-0.017,0.453-0.136,0.586-0.339c0.706-1.075,5.339-5.18,10.028-4.086 c0.215-0.545-0.198-1.081-1.175-1.612c-4.888-0.229-9.288,3.632-10.138,4.93c-0.223,0.34-0.115,0.788,0.239,0.999 C273.18,340.839,273.34,340.873,273.497,340.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M286.915,339.81c-0.104-0.696-0.884-1.418-1.382-1.557c-4.634,0.1-8.714,3.703-9.53,4.947 c-0.223,0.34-0.115,0.786,0.239,0.999c0.143,0.086,0.304,0.119,0.46,0.108c0.232-0.017,0.453-0.135,0.586-0.338 C277.974,342.924,282.372,339.035,286.915,339.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M281.942,333.315c0.211-0.834-0.034-1.473-0.987-1.787 c-5.358-1.038-10.443,3.377-11.363,4.784c-0.223,0.339-0.115,0.786,0.24,0.997c0.142,0.086,0.302,0.12,0.459,0.108 c0.232-0.017,0.453-0.135,0.586-0.34C271.635,335.923,276.929,331.272,281.942,333.315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M294.509,347.01c-0.422-0.803-1.15-1.424-2.154-1.86c-4.804-0.114-9.101,3.66-9.941,4.94 c-0.223,0.34-0.115,0.787,0.239,0.998c0.144,0.086,0.304,0.12,0.461,0.108c0.232-0.017,0.453-0.135,0.586-0.338 C284.444,349.724,289.565,345.217,294.509,347.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M279.908,347.751c0.232-0.017,0.453-0.135,0.586-0.338c0.697-1.063,5.238-5.079,9.871-4.116 c-0.201-0.677-0.736-1.222-1.626-1.599c-4.636,0.1-8.715,3.703-9.53,4.947c-0.223,0.34-0.115,0.788,0.239,0.998 C279.591,347.729,279.751,347.763,279.908,347.751z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5445_",
    style: {
      fill: "#263238"
    },
    d: "M195.645,227.561c0,0-7.157,8.176-10.602,10.652l3.231,2.797 C188.274,241.01,194.757,232.775,195.645,227.561z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "185.043,238.214 210.324,260.097 223.449,266.852 211.166,257.394 187.751,236.933  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5442_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M149.96,146.731c-3.233,4.406-13.625,29.372-18.471,79.755 c8.466,10.113,56.177,11.939,70.783-8.098c0,0-1.115-4.52-3.483-13.634c1.794-13.171,9.628-32.017,9.855-38.234 c0.25-6.857,3.027-22.137-8.774-27.057l-17.924-2.039l-25.554,1.756C156.548,139.187,153.866,141.408,149.96,146.731z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M209.314,267.137"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4564_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5403_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M174.261,84.766c0,0-4.857,0.078-7.051,3.461c-1.908,2.943-2.287,10.567-1.271,19.053 c1.016,8.485,2.318,13.682,3.231,16.108c0.913,2.426,3.286,3.368,3.286,3.368l0.964-9.802l0.485-6.853 c0,0,5.106-5.43,6.188-10.263c1.393-6.22,0.385-8.959,0.385-8.959L174.261,84.766z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5406_",
    style: {
      fill: "#37474F"
    },
    d: "M179.328,96.623c-1.208,10.082,5.987,19.234,16.068,20.442 c10.082,1.208,19.234-5.986,20.442-16.068c1.208-10.082-5.986-19.234-16.068-20.442 C189.688,79.347,180.536,86.541,179.328,96.623z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5405_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M174.296,109.046c-1.818,1.222-2.7-2.628-3.906-4.235 c-1.205-1.607-5.467-4.115-8.278,0.344c-2.864,4.545,0.662,11.631,3.836,13.606c4.65,2.894,7.471-1.806,7.471-1.806 l-2.208,22.151c0,0,0.789,4.294,8.869,8.308c6.304,3.132,16.442,0.436,11.094-6.593l0.785-6.702c0,0,5.429,1.502,8.176,1.408 c4.571-0.156,7.819-3.359,9.763-8.054c3.122-7.541,4.041-19.316,2.905-34.843c-4.545-4.503-20.965-7.134-32.327-1.75 C179.594,104.418,176.113,107.824,174.296,109.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M217.706,81.072c-0.105-0.277-0.303-0.542-0.591-0.584c-0.226-0.033-0.446,0.081-0.646,0.192 c-0.721,0.398-2.339,1.448-4.326,2.198c0.593-1.744,0.841-3.603,0.74-5.442c-0.062-1.13-0.06-3.728-1.395-4.171 c-0.795-0.263-1.589,0.33-2.265,0.823c-6.115,4.457-12.981,1.202-19.614,0.599c-5.546-0.504-12.489,0.924-15.645,5.989 c-1.443,2.317-1.959,4.883,0.088,6.86c1.747,1.687,4.134,2.646,6.425,3.342c10.77,3.27,25.124,8.866,34.523-0.394 c1.383-1.363,2.415-2.9,2.844-4.802c0.362-1.608,0.384-3.007-0.114-4.542C217.723,81.118,217.715,81.095,217.706,81.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M217.706,81.072c-0.105-0.277-0.303-0.542-0.591-0.584c-0.226-0.033-0.446,0.081-0.646,0.192 c-0.721,0.398-2.339,1.448-4.326,2.198c0.593-1.744,0.841-3.603,0.74-5.442c-0.062-1.13-0.06-3.728-1.395-4.171 c-0.795-0.263-1.589,0.33-2.265,0.823c-6.115,4.457-12.981,1.202-19.614,0.599c-5.546-0.504-12.489,0.924-15.645,5.989 c-1.443,2.317-1.959,4.883,0.088,6.86c1.747,1.687,4.134,2.646,6.425,3.342c10.77,3.27,25.124,8.866,34.523-0.394 c1.383-1.363,2.415-2.9,2.844-4.802c0.362-1.608,0.384-3.007-0.114-4.542C217.723,81.118,217.715,81.095,217.706,81.072z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5404_",
    style: {
      fill: "#F28F8F"
    },
    d: "M191.96,134.119c0,0-9.777-3.218-13.057-5.5 c-2.195-1.527-3.867-3.918-4.268-5.371c0,0,0.3,3.051,2.074,5.98c2.169,3.581,14.931,7.556,14.931,7.556L191.96,134.119z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5228_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5401_",
    style: {
      fill: "#263238"
    },
    d: "M195.744,110.415c-0.138,1.152-1.149,1.976-2.257,1.84 c-1.109-0.136-1.895-1.18-1.757-2.332c0.138-1.152,1.148-1.976,2.257-1.84C195.095,108.219,195.882,109.263,195.744,110.415z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5232_",
    style: {
      fill: "#F28F8F"
    },
    d: "M193.721,124.759c-0.138,1.152-1.149,1.976-2.257,1.84 c-1.109-0.136-1.895-1.18-1.757-2.332c0.138-1.152,1.148-1.976,2.257-1.84C193.072,122.563,193.859,123.607,193.721,124.759z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5234_",
    style: {
      fill: "#263238"
    },
    d: "M194.134,101.32l-4.767,1.298c-0.326-1.358,0.476-2.75,1.793-3.108 C192.476,99.151,193.808,99.962,194.134,101.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5231_",
    style: {
      fill: "#263238"
    },
    d: "M212.814,104.088l-4.575-1.963c0.499-1.294,1.927-1.903,3.191-1.361 C212.693,101.306,213.313,102.794,212.814,104.088z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5230_",
    style: {
      fill: "#263238"
    },
    d: "M211.35,111.559c-0.138,1.152-1.148,1.976-2.257,1.839 c-1.108-0.136-1.895-1.18-1.757-2.332c0.138-1.152,1.149-1.976,2.257-1.84C210.701,109.362,211.488,110.407,211.35,111.559z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M215,90.485c1.383-1.363,2.415-2.9,2.844-4.802c0.362-1.608,0.384-3.007-0.114-4.542 c0.877,3.217-0.242,8.071-7.644,10.31c-7.403,2.239-16.099-0.446-20.874-1.442c-4.775-0.996-8.735,0.869-8.735,0.869 C191.247,94.149,205.602,99.744,215,90.485z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M217.572,106.346c-0.267-0.058-0.547-0.115-0.837-0.17c-2.704-0.514-6.275-0.892-8.511-0.43 c-2.802,0.583-3.865,1.404-5.363,1.289c-1.601-0.139-2.506-1.123-5.297-2.167c-2.226-0.827-6.064-1.059-9.03-1.01 c-0.319,0.005-0.628,0.014-0.923,0.026c-0.509,0.02-1.131,0.626-1.185,1.388c-0.055,0.763,0.459,1.416,0.665,1.783 c0.091,0.162,0.17,0.391,0.215,0.714c0.167,1.212,0.089,3.502,0.54,4.815c0.181,0.527,0.455,1.178,0.956,1.793 c0.164,0.199,0.335,0.378,0.532,0.55c0.102,0.087,0.205,0.17,0.315,0.253c0.278,0.206,0.594,0.392,0.96,0.557 c0.055,0.024,0.109,0.049,0.164,0.069c0.084,0.033,0.172,0.069,0.261,0.101c0.089,0.032,0.181,0.061,0.275,0.091 c0.27,0.084,0.565,0.158,0.882,0.212c0.122,0.025,0.25,0.044,0.381,0.063c0.153,0.019,0.314,0.038,0.48,0.052 c3.72,0.322,5.482-1.285,6.621-3c1.141-1.712,1.206-4.264,2.921-4.116c0.057,0.006,0.111,0.012,0.163,0.023 c0.052,0.009,0.103,0.022,0.148,0.036c1.233,0.395,0.8,2.7,1.398,4.438c0.23,0.667,0.537,1.336,0.997,1.926 c0.081,0.106,0.164,0.207,0.256,0.306c0.045,0.052,0.091,0.099,0.139,0.146c0.048,0.049,0.096,0.095,0.147,0.142 c0.044,0.041,0.089,0.081,0.135,0.12c0.079,0.066,0.113,0.095,0.147,0.121c0.038,0.031,0.077,0.061,0.118,0.089 c0.026,0.021,0.054,0.041,0.082,0.061c0.397,0.281,0.863,0.522,1.412,0.704c0.043,0.014,0.088,0.029,0.133,0.042 c0.519,0.163,1.113,0.276,1.791,0.327c3.486,0.272,4.927-1.629,5.649-2.846c0.72-1.219,1.207-3.469,1.63-4.639 c0.094-0.259,0.24-0.452,0.391-0.594c0.288-0.27,0.861-0.925,0.995-1.678C218.46,107.178,218.033,106.446,217.572,106.346z  M198.912,111.559c-0.241,0.675-0.701,1.638-1.59,2.388l-0.003,0.001c-0.897,0.752-2.234,1.285-4.227,1.09 c-2.015-0.196-3.093-1.117-3.682-2.141c-0.037-0.063-0.072-0.127-0.102-0.189c-0.035-0.064-0.065-0.125-0.092-0.187 c-0.028-0.058-0.053-0.116-0.076-0.175c-0.021-0.051-0.043-0.105-0.061-0.157c-0.018-0.042-0.033-0.083-0.045-0.124 c-0.015-0.039-0.028-0.076-0.039-0.112c-0.02-0.062-0.04-0.126-0.058-0.186l0-0.002c-0.055-0.187-0.098-0.366-0.132-0.54 c-0.002-0.004-0.002-0.008-0.003-0.014c-0.021-0.11-0.041-0.218-0.058-0.321c-0.03-0.187-0.051-0.362-0.067-0.516 c-0.003-0.034-0.007-0.067-0.01-0.099c-0.004-0.032-0.007-0.063-0.011-0.094c-0.137-1.275-0.182-3.762,0.523-4.264 c0.682-0.483,2.468-0.938,5.206-0.445c0.094,0.012,0.192,0.031,0.292,0.052c0.419,0.084,0.834,0.189,1.24,0.317 c0.162,0.049,0.321,0.103,0.477,0.158c0.421,0.148,0.824,0.316,1.186,0.494c0.125,0.061,0.246,0.123,0.359,0.185 c0.137,0.072,0.265,0.148,0.386,0.224c0.026,0.016,0.051,0.031,0.077,0.049c0.049,0.03,0.095,0.06,0.139,0.094 c0.358,0.244,0.621,0.494,0.751,0.724C199.754,108.585,199.393,110.193,198.912,111.559z M215.137,112.359 c-0.331,0.959-1.045,3.029-3.098,3.791c-0.585,0.218-1.286,0.328-2.114,0.271c-2.199-0.141-3.335-1.136-3.917-2.215 c-0.004-0.007-0.008-0.014-0.009-0.02c-0.023-0.042-0.044-0.082-0.063-0.121c-0.025-0.048-0.047-0.096-0.068-0.14 c-0.011-0.023-0.022-0.048-0.033-0.073c-0.029-0.068-0.058-0.139-0.083-0.206c-0.03-0.08-0.057-0.159-0.083-0.241 c-0.014-0.038-0.026-0.077-0.037-0.116c-0.007-0.023-0.011-0.043-0.018-0.066c-0.01-0.033-0.018-0.066-0.026-0.098 c-0.006-0.026-0.014-0.052-0.019-0.075c-0.086-0.349-0.131-0.675-0.155-0.955c-0.117-1.415-0.074-3.048,0.541-3.773 c0.614-0.725,2.759-1.399,4.755-1.477c0.46-0.018,0.889-0.013,1.284,0.012c0.051,0.003,0.102,0.007,0.151,0.011 c0.056,0.004,0.109,0.009,0.163,0.014c0.151,0.013,0.299,0.031,0.44,0.048c0.053,0.007,0.106,0.014,0.16,0.023 c0.071,0.012,0.14,0.022,0.206,0.035c0.118,0.019,0.232,0.042,0.341,0.067c0.224,0.048,0.433,0.103,0.625,0.164 c0.05,0.016,0.099,0.032,0.146,0.049c0.011,0.003,0.025,0.007,0.038,0.013c0.031,0.011,0.065,0.021,0.099,0.036 c0.05,0.016,0.101,0.037,0.148,0.056c0.06,0.023,0.121,0.05,0.177,0.074c0.105,0.046,0.199,0.094,0.287,0.143 c0.018,0.009,0.033,0.017,0.051,0.028c0.285,0.158,0.495,0.323,0.633,0.479C216.189,108.696,215.558,111.13,215.137,112.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M187.724,104.156l-19.702-1.154c1.405,0.641,1.968,1.222,2.734,2.361l16.408,1.14 L187.724,104.156z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5421_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5422_",
    style: {
      fill: "#F28F8F"
    },
    d: "M201.561,109.633l-0.898,10.505l6.848-1.512l-5.182-9.413 C201.984,109.256,201.625,109.537,201.561,109.633z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_622_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_623_",
    style: {
      fill: "#455A64"
    },
    points: "266.798,336.322 149.673,268.699 306.42,178.575 423.545,246.197  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_620_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_621_",
    style: {
      fill: "#263238"
    },
    points: "149.673,268.699 149.674,376.126 155.839,379.685 155.839,289.352  260.634,349.856 260.635,440.19 266.799,443.749 266.798,336.322  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_618_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_619_",
    points: "155.839,379.685 162.003,376.126 162.003,292.911 155.839,289.352  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_616_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_617_",
    style: {
      fill: "#37474F"
    },
    points: "266.799,443.749 272.964,440.19 272.963,349.856 417.381,266.85  417.381,357.184 423.546,353.625 423.545,246.197 266.798,336.322  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_614_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_615_",
    style: {
      fill: "#263238"
    },
    points: "417.381,357.184 411.217,353.625 411.216,270.409 417.381,266.85  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_613_",
    style: {
      opacity: 0.2
    },
    d: "M297.465,235.128c-0.429,0-0.843-0.103-1.167-0.289l-31.746-18.278 c-0.444-0.257-0.699-0.657-0.699-1.099c0-0.442,0.255-0.843,0.699-1.099l41.091-23.74l34.817,20.052l-41.828,24.166 C298.308,235.025,297.894,235.128,297.465,235.128z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_558_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_559_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_609_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_612_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M306.943,190.868l-40.904,21.971l-0.672,1.056v0.85 c0,0.424,0.245,0.809,0.672,1.056l30.491,17.556c0.311,0.179,0.709,0.278,1.121,0.278c0.412,0,0.81-0.099,1.121-0.278 l40.175-23.21v-0.851L306.943,190.868z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_611_",
    style: {
      opacity: 0.2
    },
    d: "M306.943,190.868l-40.904,21.971l-0.672,1.056v0.85 c0,0.424,0.245,0.809,0.672,1.056l30.491,17.556c0.311,0.179,0.709,0.278,1.121,0.278c0.412,0,0.81-0.099,1.121-0.278 l40.175-23.21v-0.851L306.943,190.868z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_610_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M297.65,232.785c-0.412,0-0.81-0.099-1.121-0.278l-30.491-17.556 c-0.427-0.247-0.672-0.632-0.672-1.056c0-0.425,0.245-0.809,0.672-1.056l39.467-22.802l33.44,19.259l-40.175,23.21 C298.46,232.686,298.062,232.785,297.65,232.785z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_605_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_608_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M305.505,187.542l-39.112,22.597l-0.318,0.443v3.313l0,0 c0,0.16,0.106,0.32,0.318,0.442l30.491,17.556c0.423,0.245,1.11,0.245,1.533,0l39.113-22.597v-3.314L305.505,187.542z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_607_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M337.531,205.984l-0.386,0.223l-5.024,2.9l-0.935,0.542l-32.768,18.931 c-0.425,0.244-1.112,0.244-1.533,0l-30.494-17.557c-0.421-0.245-0.421-0.641,0-0.885l0.411-0.237l38.703-22.359 l31.644,18.219l0.092,0.057L337.531,205.984z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_606_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M297.65,228.764v3.313c-0.276,0-0.556-0.06-0.765-0.184l-30.494-17.557 c-0.209-0.12-0.315-0.28-0.315-0.443v-3.313c0,0.159,0.106,0.319,0.315,0.443l30.494,17.557 C297.094,228.704,297.374,228.764,297.65,228.764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_604_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M337.531,205.542l-5.559,3.208l-0.871,0.503l-32.683,18.885 c-0.425,0.244-1.112,0.244-1.533,0l-25.994-14.958c-0.347-0.191-0.669-0.379-0.97-0.559 c-1.569-0.956-2.514-1.809-3.119-2.719c-0.025-0.039-0.05-0.074-0.074-0.113c-0.049-0.074-0.081-0.152-0.096-0.23 c-0.071-0.34,0.156-0.666,0.538-0.779c0.747-0.223,1.876-0.62,2.907-1.211c0.014-0.007,0.025-0.014,0.039-0.021 l35.388-20.447L337.531,205.542z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_574_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_599_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_603_",
    style: {
      opacity: 0.1
    },
    d: "M331.777,205.153c-0.393,0.229-0.393,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.83C332.811,204.924,332.17,204.924,331.777,205.153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_601_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M336.377,202.469c-0.545-0.315-1.228-0.265-1.926,0.135 c-1.08,0.627-2.015,2.022-2.422,3.484c0.163,0.053,0.347,0.075,0.527,0.064c0.375-1.303,1.204-2.531,2.16-3.087 c0.311-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774 c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.482,0.053-0.715 C337.368,203.648,337.007,202.833,336.377,202.469z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_600_",
    style: {
      fill: "#263238"
    },
    d: "M337.266,205.694c-0.004,0.039-0.014,0.081-0.025,0.124l-0.092-0.057 L337.266,205.694z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_595_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_598_",
    style: {
      opacity: 0.1
    },
    d: "M327.463,202.661c-0.393,0.229-0.393,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.831C328.497,202.432,327.856,202.432,327.463,202.661z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_596_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M332.063,199.977c-0.545-0.315-1.229-0.266-1.926,0.135 c-1.08,0.627-2.014,2.022-2.422,3.484c0.163,0.053,0.347,0.075,0.527,0.064c0.376-1.303,1.204-2.531,2.16-3.087 c0.312-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774 c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.482,0.053-0.715 C333.054,201.156,332.693,200.342,332.063,199.977z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_591_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_594_",
    style: {
      opacity: 0.1
    },
    d: "M323.148,200.17c-0.393,0.229-0.393,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.83C324.182,199.941,323.541,199.941,323.148,200.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_592_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M327.748,197.486c-0.545-0.315-1.229-0.266-1.926,0.134 c-1.08,0.627-2.015,2.022-2.422,3.484c0.163,0.053,0.347,0.074,0.527,0.064c0.375-1.303,1.204-2.531,2.16-3.087 c0.311-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.265,0.726,0.913,0.726,1.774 c0,0.142-0.007,0.284-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.481,0.053-0.715 C328.739,198.665,328.378,197.85,327.748,197.486z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_587_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_590_",
    style: {
      opacity: 0.1
    },
    d: "M318.833,197.68c-0.393,0.229-0.394,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.83C319.867,197.45,319.227,197.45,318.833,197.68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_588_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M323.433,194.995c-0.545-0.315-1.229-0.266-1.926,0.135 c-1.08,0.627-2.014,2.021-2.422,3.484c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.532,2.159-3.087 c0.312-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.913,0.726,1.774 c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.481,0.053-0.715 C324.425,196.174,324.064,195.36,323.433,194.995z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_583_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_586_",
    style: {
      opacity: 0.1
    },
    d: "M314.519,195.189c-0.393,0.229-0.394,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.83C315.553,194.959,314.912,194.959,314.519,195.189z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_584_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M319.119,192.504c-0.545-0.315-1.228-0.266-1.926,0.135 c-1.08,0.626-2.015,2.022-2.422,3.484c0.163,0.053,0.347,0.075,0.528,0.064c0.375-1.303,1.204-2.531,2.16-3.087 c0.312-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.265,0.726,0.913,0.726,1.774 c0,0.142-0.007,0.284-0.025,0.425l0.502,0.29c0.036-0.241,0.053-0.482,0.053-0.715 C320.11,193.683,319.749,192.869,319.119,192.504z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_579_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_582_",
    style: {
      opacity: 0.1
    },
    d: "M310.203,192.697c-0.393,0.229-0.393,0.601,0,0.831 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.23,0.397-0.601,0-0.831C311.237,192.468,310.597,192.468,310.203,192.697z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_580_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M314.803,190.013c-0.545-0.315-1.228-0.265-1.926,0.135 c-1.08,0.627-2.015,2.022-2.422,3.484c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.532,2.16-3.087 c0.312-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.913,0.726,1.774 c0,0.141-0.007,0.283-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.482,0.053-0.715 C315.795,191.192,315.434,190.378,314.803,190.013z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_575_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_578_",
    style: {
      opacity: 0.1
    },
    d: "M305.889,190.206c-0.393,0.229-0.393,0.601,0,0.83 c0.393,0.229,1.034,0.229,1.431,0c0.397-0.229,0.397-0.601,0-0.83C306.923,189.977,306.283,189.977,305.889,190.206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_576_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M310.489,187.522c-0.545-0.315-1.228-0.266-1.926,0.134 c-1.08,0.627-2.015,2.022-2.422,3.484c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.531,2.16-3.087 c0.312-0.177,0.609-0.269,0.878-0.269c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774 c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29c0.035-0.241,0.053-0.482,0.053-0.715 C311.481,188.701,311.12,187.887,310.489,187.522z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_572_",
    d: "M336.377,202.469c-0.545-0.315-1.228-0.265-1.926,0.135c-1.08,0.627-2.015,2.022-2.422,3.484 c0.163,0.053,0.347,0.075,0.527,0.064c0.375-1.303,1.204-2.531,2.16-3.087c0.311-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.482,0.053-0.715C337.368,203.648,337.007,202.833,336.377,202.469z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_570_",
    d: "M332.063,199.977c-0.545-0.315-1.229-0.266-1.926,0.135c-1.08,0.627-2.014,2.022-2.422,3.484 c0.163,0.053,0.347,0.075,0.527,0.064c0.376-1.303,1.204-2.531,2.16-3.087c0.312-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.482,0.053-0.715C333.054,201.156,332.693,200.342,332.063,199.977z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_568_",
    d: "M327.748,197.486c-0.545-0.315-1.229-0.266-1.926,0.134c-1.08,0.627-2.015,2.022-2.422,3.484 c0.163,0.053,0.347,0.074,0.527,0.064c0.375-1.303,1.204-2.531,2.16-3.087c0.311-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.265,0.726,0.913,0.726,1.774c0,0.142-0.007,0.284-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.481,0.053-0.715C328.739,198.665,328.378,197.85,327.748,197.486z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_566_",
    d: "M323.433,194.995c-0.545-0.315-1.229-0.266-1.926,0.135c-1.08,0.627-2.014,2.021-2.422,3.484 c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.532,2.159-3.087c0.312-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.913,0.726,1.774c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.481,0.053-0.715C324.425,196.174,324.064,195.36,323.433,194.995z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_564_",
    d: "M319.119,192.504c-0.545-0.315-1.228-0.266-1.926,0.135c-1.08,0.626-2.015,2.022-2.422,3.484 c0.163,0.053,0.347,0.075,0.528,0.064c0.375-1.303,1.204-2.531,2.16-3.087c0.312-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.265,0.726,0.913,0.726,1.774c0,0.142-0.007,0.284-0.025,0.425l0.502,0.29 c0.036-0.241,0.053-0.482,0.053-0.715C320.11,193.683,319.749,192.869,319.119,192.504z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    d: "M314.803,190.013c-0.545-0.315-1.228-0.265-1.926,0.135c-1.08,0.627-2.015,2.022-2.422,3.484 c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.532,2.16-3.087c0.312-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.913,0.726,1.774c0,0.141-0.007,0.283-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.482,0.053-0.715C315.795,191.192,315.434,190.378,314.803,190.013z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    d: "M310.489,187.522c-0.545-0.315-1.228-0.266-1.926,0.134c-1.08,0.627-2.015,2.022-2.422,3.484 c0.163,0.053,0.347,0.074,0.528,0.064c0.375-1.303,1.204-2.531,2.16-3.087c0.312-0.177,0.609-0.269,0.878-0.269 c0.188,0,0.361,0.046,0.517,0.135c0.46,0.266,0.726,0.914,0.726,1.774c0,0.142-0.007,0.283-0.025,0.425l0.503,0.29 c0.035-0.241,0.053-0.482,0.053-0.715C311.481,188.701,311.12,187.887,310.489,187.522z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_557_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.183,
      strokeMiterlimit: 10
    },
    d: "M325.848,205.847 l-30.561,17.616c-0.425,0.244-0.372,0.672,0.117,0.955l1.809,1.047c0.49,0.283,1.231,0.314,1.656,0.07l30.561-17.616 c0.425-0.245,0.372-0.672-0.117-0.955l-1.809-1.047C327.014,205.634,326.272,205.603,325.848,205.847z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_556_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.183,
      strokeMiterlimit: 10
    },
    x1: 296.308,
    y1: 224.942,
    x2: 328.407,
    y2: 206.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_555_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    d: "M271.873,209.833 l30.445-17.549c0.457-0.263,1.196-0.263,1.652,0.001l19.94,11.554c0.456,0.264,0.455,0.691-0.002,0.954l-30.445,17.549 c-0.457,0.263-1.196,0.263-1.652-0.001l-19.94-11.554C271.415,210.523,271.416,210.096,271.873,209.833z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_554_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 290.834,
    y1: 221.775,
    x2: 322.934,
    y2: 203.273
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_553_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 289.033,
    y1: 220.732,
    x2: 321.132,
    y2: 202.23
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_552_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 287.231,
    y1: 219.689,
    x2: 319.33,
    y2: 201.187
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_551_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 285.429,
    y1: 218.646,
    x2: 317.528,
    y2: 200.144
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_550_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 283.627,
    y1: 217.604,
    x2: 315.726,
    y2: 199.102
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_549_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 281.825,
    y1: 216.561,
    x2: 313.924,
    y2: 198.059
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_548_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 280.023,
    y1: 215.518,
    x2: 312.122,
    y2: 197.016
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_547_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 278.221,
    y1: 214.475,
    x2: 310.321,
    y2: 195.973
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_546_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 276.419,
    y1: 213.433,
    x2: 308.519,
    y2: 194.931
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_545_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 274.618,
    y1: 212.39,
    x2: 306.717,
    y2: 193.888
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_544_",
    style: {
      fill: "none",
      stroke: "#E0E0E0",
      strokeWidth: 0.1836,
      strokeMiterlimit: 10
    },
    x1: 272.816,
    y1: 211.347,
    x2: 304.915,
    y2: 192.845
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M302.951,215.799c0.012,0.09,0.113,0.089,0.124-0.001c0.047-0.372,0.27-0.542,0.618-0.563 c0.227-0.013,0.485-0.044,0.707,0.015c0.04,0.011,0.068-0.021,0.08-0.056c0.07-0.212,0.083-0.449,0.196-0.643 c0.161,0.123,0.366,0.26,0.506,0.064c0.154-0.216,0.034-0.921,0.437-0.52c0.04,0.04,0.084,0.036,0.114-0.012 c0.228-0.36,0.484-0.377,0.668-0.153c0.05,0.142,0.114,0.271,0.182,0.365c0.067,0.091,0.129-0.045,0.113-0.108 c-0.025-0.099-0.057-0.207-0.102-0.309c-0.033-0.295,0.036-0.711,0.208-0.833c0.39-0.276,0.846,0.387,0.906,0.705l0.001,0 c0.003,0.011,0.005,0.023,0.007,0.034c0.035,0.143,0.186,0.069,0.164-0.059c-0.002-0.013-0.006-0.028-0.009-0.042 c-0.068-0.269-0.004-0.686,0.137-0.924c0.214-0.362,0.484-0.182,0.715,0.09c0.069,0.082,0.124-0.025,0.124-0.091 c-0.005-0.439,0.349-1.06,0.764-0.526c0.054,0.069,0.121,0.006,0.138-0.052c0.048-0.172,0.088-0.345,0.134-0.517 c0.028-0.123,0.066-0.242,0.114-0.358c0.02-0.183,0.081-0.203,0.182-0.06c0.153,0.09,0.26,0.335,0.468,0.315 c0.285-0.028,0.322-0.418,0.309-0.693c0.167,0.086,0.373,0.174,0.531,0.072c0.16-0.104,0.21-0.359,0.24-0.553 c0.135,0.124,0.295,0.249,0.47,0.137c0.171-0.109,0.237-0.423,0.281-0.643c0.21,0.077,0.353,0.19,0.467,0.398 c0.042,0.076,0.099-0.015,0.103-0.062c0.016-0.211-0.057-0.577,0.051-0.763c0.22-0.378,0.685,0.292,0.779,0.535 c0.048,0.123,0.187,0.094,0.183-0.037c-0.012-0.392-0.111-1.588,0.507-1.533c0.096,0.009,0.196,0.05,0.295,0.115 c-0.191,0.652,0.111,1.403,0.768,1.665c0.047,0.019,0.091,0.004,0.111-0.046c0.21-0.528-0.163-1.305-0.631-1.736 c0.047-0.085,0.106-0.165,0.182-0.238c0.216-0.207,0.524-0.072,0.706-0.292c0.123-0.149,0.052-0.165,0.243-0.296 c0.194-0.132,0.244-0.084,0.409,0.062c0.081,0.072,0.138,0.148,0.198,0.238c0.052,0.079,0.123-0.008,0.128-0.066 c0.016-0.169,0.03-0.521,0.243-0.581c0.183-0.051,0.392,0.153,0.507,0.256c0.06,0.054,0.12,0.02,0.138-0.052 c0.026-0.104,0.032-0.21,0.044-0.316c0.007-0.065,0.004-0.154,0.026-0.217c0.06-0.169,0.322-0.47,0.454-0.017 c0.037,0.127,0.183,0.09,0.179-0.034c-0.009-0.326,0.098-0.676,0.331-0.913c0.122-0.124,0.269-0.215,0.447-0.227 c0.001,0,0.003,0,0.004,0c-0.025,0.06-0.042,0.125-0.046,0.196c-0.015,0.227,0.089,0.604,0.343,0.67 c0.221,0.057,0.403-0.139,0.452-0.337c0.069-0.281-0.099-0.533-0.336-0.668c-0.012-0.007-0.024-0.01-0.036-0.017 c0.157-0.109,0.347-0.178,0.521-0.243c0.14-0.053,0.329-0.087,0.449-0.181c0.053-0.042,0.096-0.178,0.139-0.201 c0.403-0.216,0.204,0.055,0.4,0.046c0.377-0.017,0.551-0.195,0.643-0.509c0.329,0.333,0.614-0.168,0.723-0.536 c0.142,0.203,0.314,0.525,0.547,0.583c0.242,0.061,0.467-0.166,0.628-0.308c0.006-0.005,0.008-0.026-0.003-0.018 c-0.218,0.163-0.456,0.352-0.71,0.154c-0.183-0.143-0.312-0.403-0.448-0.587c-0.026-0.035-0.064,0.007-0.07,0.033 c-0.058,0.246-0.327,0.933-0.649,0.469c-0.039-0.056-0.089-0.013-0.101,0.038c-0.096,0.398-0.292,0.509-0.677,0.412 c-0.156-0.039-0.191-0.073-0.335,0.02c-0.098,0.063-0.127,0.195-0.243,0.261c-0.055,0.031-0.132,0.049-0.192,0.07 c-0.18,0.064-0.363,0.12-0.533,0.208c-0.11,0.057-0.214,0.127-0.301,0.211c-0.577-0.132-1.004,0.474-1.112,1.043 c-0.128-0.132-0.311-0.19-0.495-0.046c-0.195,0.153-0.178,0.456-0.201,0.705c-0.175-0.145-0.401-0.292-0.613-0.179 c-0.187,0.099-0.244,0.336-0.264,0.551c-0.212-0.248-0.53-0.461-0.79-0.182c-0.195,0.209,0.2,0.188-0.402,0.401 c-0.076,0.027-0.16-0.004-0.245,0.032c-0.167,0.07-0.309,0.258-0.398,0.408c-0.014,0.023-0.021,0.049-0.033,0.073 c-0.074-0.054-0.149-0.099-0.224-0.131c-0.833-0.361-0.901,0.667-0.889,1.349c-0.174-0.263-0.424-0.519-0.68-0.5 c-0.395,0.029-0.323,0.585-0.27,0.958c-0.12-0.142-0.26-0.245-0.455-0.317c-0.035-0.013-0.068,0.02-0.077,0.052 c-0.039,0.142-0.04,0.32-0.095,0.453c-0.136,0.331-0.368,0.212-0.548,0.035c-0.035-0.034-0.073,0.008-0.08,0.043 c-0.034,0.162-0.059,0.494-0.241,0.57c-0.168,0.07-0.389-0.121-0.51-0.209c-0.056-0.041-0.107,0.027-0.108,0.08 c-0.005,0.238,0.074,0.755-0.366,0.512c-0.141-0.077-0.224-0.249-0.376-0.328c-0.033-0.017-0.075-0.012-0.097,0.021 c-0.213,0.317-0.232,0.673-0.327,1.027c-0.44-0.497-0.884,0.054-0.931,0.615c-0.222-0.245-0.529-0.431-0.801-0.122 c-0.179,0.204-0.243,0.469-0.249,0.74c-0.228-0.358-0.582-0.654-0.958-0.493c-0.336,0.144-0.414,0.515-0.37,0.884 c-0.029-0.017-0.059-0.031-0.093-0.042c-0.299-0.097-0.478,0.119-0.585,0.359c-0.075-0.055-0.15-0.108-0.22-0.17 c-0.014-0.012-0.05-0.017-0.065-0.005c-0.143,0.117-0.2,0.25-0.238,0.428c-0.015,0.072-0.003,0.198-0.04,0.261 c-0.116,0.197-0.263,0.002-0.387-0.116c-0.025-0.024-0.076-0.042-0.106-0.014c-0.217,0.205-0.138,0.39-0.212,0.65 c-0.056,0.197-0.061,0.134-0.287,0.07c-0.141-0.04-0.258-0.069-0.404-0.065C303.1,214.907,302.878,215.247,302.951,215.799z  M319.946,206.082c0.015,0.141-0.127,0.32-0.28,0.275c-0.252-0.074-0.236-0.404-0.118-0.608 C319.73,205.796,319.928,205.91,319.946,206.082z M315.59,209.891c-0.459-0.229-0.696-0.762-0.575-1.237 C315.364,208.969,315.65,209.526,315.59,209.891z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M292.632,209.652c0.012,0.09,0.113,0.089,0.124-0.001c0.047-0.372,0.27-0.542,0.618-0.563 c0.227-0.013,0.485-0.044,0.708,0.015c0.04,0.011,0.068-0.021,0.08-0.056c0.071-0.212,0.083-0.45,0.196-0.643 c0.161,0.123,0.366,0.26,0.506,0.064c0.154-0.216,0.034-0.922,0.437-0.52c0.04,0.04,0.083,0.036,0.114-0.013 c0.227-0.36,0.484-0.377,0.668-0.152c0.051,0.142,0.114,0.271,0.182,0.365c0.066,0.091,0.129-0.044,0.113-0.108 c-0.025-0.099-0.057-0.208-0.102-0.309c-0.033-0.295,0.036-0.711,0.208-0.833c0.39-0.276,0.846,0.387,0.906,0.705l0.001,0 c0.003,0.011,0.005,0.023,0.007,0.034c0.035,0.142,0.186,0.069,0.165-0.059c-0.002-0.013-0.006-0.028-0.009-0.042 c-0.067-0.269-0.004-0.686,0.137-0.924c0.214-0.362,0.484-0.182,0.715,0.091c0.069,0.082,0.124-0.025,0.124-0.091 c-0.005-0.439,0.349-1.06,0.764-0.525c0.054,0.069,0.121,0.006,0.138-0.052c0.048-0.172,0.088-0.345,0.134-0.517 c0.028-0.123,0.066-0.242,0.114-0.358c0.02-0.183,0.081-0.203,0.182-0.06c0.153,0.09,0.259,0.335,0.468,0.315 c0.285-0.027,0.322-0.418,0.309-0.693c0.167,0.086,0.373,0.173,0.531,0.072c0.16-0.103,0.21-0.359,0.24-0.553 c0.135,0.124,0.295,0.249,0.47,0.137c0.171-0.109,0.237-0.423,0.281-0.643c0.21,0.077,0.353,0.19,0.467,0.398 c0.042,0.076,0.1-0.015,0.103-0.062c0.016-0.211-0.057-0.577,0.051-0.763c0.22-0.378,0.685,0.292,0.779,0.535 c0.048,0.123,0.187,0.094,0.183-0.037c-0.012-0.392-0.111-1.588,0.507-1.533c0.096,0.009,0.196,0.05,0.295,0.115 c-0.191,0.652,0.111,1.403,0.769,1.665c0.047,0.019,0.091,0.004,0.111-0.046c0.211-0.528-0.163-1.305-0.631-1.736 c0.047-0.085,0.106-0.165,0.182-0.238c0.216-0.207,0.524-0.072,0.706-0.292c0.123-0.149,0.052-0.165,0.243-0.296 c0.194-0.132,0.243-0.084,0.409,0.063c0.081,0.072,0.138,0.148,0.198,0.238c0.052,0.079,0.122-0.008,0.128-0.066 c0.016-0.169,0.03-0.522,0.243-0.581c0.183-0.051,0.392,0.153,0.507,0.256c0.06,0.054,0.12,0.02,0.138-0.052 c0.026-0.104,0.032-0.21,0.044-0.316c0.007-0.065,0.004-0.154,0.026-0.217c0.06-0.169,0.322-0.47,0.454-0.017 c0.037,0.127,0.183,0.09,0.179-0.034c-0.009-0.326,0.098-0.676,0.331-0.913c0.122-0.124,0.269-0.215,0.447-0.227 c0.001,0,0.003,0,0.004,0c-0.025,0.06-0.042,0.125-0.046,0.196c-0.015,0.227,0.089,0.604,0.343,0.67 c0.221,0.057,0.403-0.139,0.452-0.337c0.069-0.281-0.1-0.533-0.336-0.668c-0.012-0.007-0.024-0.01-0.036-0.017 c0.157-0.109,0.347-0.178,0.521-0.243c0.14-0.053,0.329-0.087,0.449-0.181c0.053-0.042,0.096-0.178,0.138-0.201 c0.403-0.216,0.204,0.055,0.4,0.046c0.377-0.017,0.551-0.195,0.643-0.509c0.329,0.333,0.614-0.168,0.723-0.536 c0.141,0.203,0.314,0.524,0.546,0.583c0.242,0.06,0.467-0.166,0.628-0.308c0.006-0.005,0.008-0.026-0.003-0.018 c-0.218,0.163-0.456,0.352-0.71,0.154c-0.183-0.143-0.312-0.403-0.448-0.587c-0.025-0.034-0.064,0.007-0.07,0.033 c-0.058,0.246-0.327,0.933-0.649,0.469c-0.039-0.056-0.089-0.013-0.101,0.038c-0.095,0.398-0.292,0.509-0.677,0.411 c-0.156-0.039-0.191-0.072-0.335,0.02c-0.098,0.063-0.127,0.195-0.243,0.261c-0.055,0.031-0.133,0.048-0.192,0.069 c-0.18,0.064-0.363,0.12-0.533,0.208c-0.11,0.057-0.214,0.127-0.301,0.211c-0.577-0.132-1.004,0.474-1.112,1.043 c-0.128-0.133-0.311-0.19-0.495-0.046c-0.195,0.153-0.178,0.456-0.201,0.705c-0.175-0.145-0.401-0.292-0.613-0.179 c-0.187,0.099-0.244,0.336-0.264,0.551c-0.212-0.249-0.53-0.461-0.789-0.183c-0.195,0.209,0.2,0.188-0.402,0.401 c-0.076,0.027-0.16-0.004-0.245,0.032c-0.167,0.07-0.309,0.258-0.398,0.408c-0.014,0.023-0.021,0.049-0.033,0.073 c-0.074-0.054-0.15-0.099-0.224-0.131c-0.833-0.361-0.901,0.667-0.889,1.349c-0.174-0.263-0.424-0.519-0.68-0.501 c-0.395,0.029-0.323,0.586-0.27,0.958c-0.12-0.142-0.26-0.245-0.455-0.317c-0.035-0.013-0.068,0.02-0.077,0.052 c-0.039,0.142-0.04,0.32-0.095,0.453c-0.136,0.331-0.368,0.212-0.548,0.035c-0.035-0.034-0.073,0.007-0.08,0.043 c-0.034,0.162-0.059,0.493-0.241,0.57c-0.168,0.07-0.389-0.121-0.511-0.209c-0.056-0.041-0.107,0.027-0.108,0.08 c-0.005,0.237,0.074,0.755-0.366,0.512c-0.141-0.077-0.224-0.249-0.376-0.328c-0.033-0.017-0.075-0.012-0.097,0.021 c-0.213,0.317-0.232,0.673-0.327,1.027c-0.44-0.497-0.884,0.054-0.931,0.615c-0.222-0.245-0.528-0.431-0.8-0.122 c-0.179,0.204-0.243,0.47-0.249,0.74c-0.227-0.358-0.582-0.654-0.958-0.493c-0.336,0.144-0.414,0.515-0.37,0.884 c-0.029-0.017-0.059-0.031-0.093-0.042c-0.299-0.097-0.478,0.119-0.585,0.359c-0.075-0.055-0.15-0.108-0.22-0.17 c-0.014-0.013-0.05-0.017-0.065-0.005c-0.143,0.117-0.199,0.25-0.238,0.428c-0.015,0.072-0.003,0.198-0.04,0.261 c-0.116,0.197-0.263,0.002-0.387-0.116c-0.025-0.024-0.076-0.042-0.106-0.014c-0.217,0.204-0.138,0.39-0.212,0.65 c-0.056,0.198-0.061,0.134-0.287,0.071c-0.141-0.04-0.258-0.069-0.404-0.065C292.782,208.759,292.559,209.099,292.632,209.652z  M309.627,199.934c0.015,0.141-0.127,0.32-0.28,0.275c-0.252-0.074-0.237-0.405-0.119-0.608 C309.411,199.649,309.609,199.762,309.627,199.934z M305.272,203.744c-0.459-0.229-0.696-0.762-0.575-1.237 C305.045,202.821,305.332,203.379,305.272,203.744z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M315.178,203.214c0.181-0.011,0.383-0.08,0.522-0.207c0.229,0.229,0.509,0.435,0.649,0.63 c0.066,0.092,0.131-0.035,0.127-0.098c-0.012-0.204,0.109-0.453,0.255-0.59c0.147-0.139,0.253-0.101,0.429-0.067 c0.201,0.039,0.272-0.066,0.278-0.217c0.262,0.105,0.403-0.171,0.483-0.427c0.118,0.099,0.255,0.169,0.403,0.073 c0.153-0.099,0.232-0.304,0.298-0.473c0.216,0.148,0.318,0.57,0.641,0.502c0.263-0.056,0.47-0.43,0.523-0.67 c0.014-0.066-0.052-0.078-0.068-0.013c-0.055,0.231-0.33,0.664-0.612,0.527c-0.218-0.106-0.265-0.402-0.48-0.514 c-0.023-0.012-0.049,0.008-0.058,0.029c-0.128,0.304-0.294,0.682-0.64,0.345c-0.038-0.038-0.074,0.012-0.084,0.046 c-0.06,0.212-0.169,0.563-0.446,0.361c-0.065-0.048-0.099,0.053-0.091,0.103c0.037,0.236-0.165,0.115-0.3,0.093 c-0.12-0.019-0.218,0.013-0.315,0.086c-0.18,0.136-0.313,0.363-0.359,0.594c-0.113-0.118-0.246-0.222-0.363-0.332 c-0.042-0.04-0.097-0.089-0.153-0.144c0.012-0.026,0.024-0.052,0.032-0.08c0.078-0.287-0.088-0.621-0.39-0.677 c-0.043-0.008-0.067,0.02-0.081,0.058c-0.097,0.26,0.007,0.491,0.18,0.701c-0.127,0.075-0.279,0.083-0.405,0.158 C315.093,203.046,315.083,203.219,315.178,203.214z M315.506,202.335c0.168,0.061,0.25,0.234,0.182,0.38 C315.585,202.596,315.503,202.463,315.506,202.335z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297.915,217.625c0.181-0.011,0.383-0.08,0.522-0.207c0.229,0.229,0.509,0.435,0.649,0.63 c0.066,0.092,0.131-0.035,0.127-0.098c-0.012-0.204,0.109-0.453,0.255-0.591c0.147-0.139,0.253-0.101,0.429-0.067 c0.201,0.039,0.272-0.066,0.278-0.217c0.262,0.105,0.403-0.171,0.483-0.427c0.118,0.099,0.255,0.169,0.403,0.073 c0.153-0.099,0.232-0.304,0.299-0.473c0.216,0.148,0.318,0.57,0.641,0.502c0.264-0.056,0.47-0.43,0.523-0.67 c0.014-0.066-0.052-0.078-0.068-0.013c-0.055,0.231-0.33,0.664-0.612,0.527c-0.218-0.106-0.265-0.402-0.481-0.514 c-0.023-0.012-0.049,0.008-0.058,0.029c-0.129,0.304-0.294,0.682-0.64,0.345c-0.038-0.037-0.074,0.012-0.084,0.046 c-0.06,0.212-0.169,0.563-0.446,0.361c-0.065-0.048-0.099,0.053-0.091,0.103c0.037,0.236-0.165,0.115-0.3,0.093 c-0.12-0.019-0.218,0.013-0.315,0.086c-0.18,0.136-0.313,0.363-0.359,0.594c-0.113-0.118-0.246-0.222-0.363-0.332 c-0.042-0.04-0.097-0.089-0.154-0.144c0.012-0.026,0.024-0.052,0.032-0.08c0.078-0.287-0.088-0.621-0.39-0.677 c-0.043-0.008-0.067,0.021-0.081,0.058c-0.097,0.26,0.007,0.491,0.18,0.701c-0.127,0.074-0.279,0.083-0.405,0.158 C297.831,217.457,297.82,217.63,297.915,217.625z M298.244,216.746c0.168,0.061,0.249,0.234,0.182,0.38 C298.323,217.007,298.241,216.874,298.244,216.746z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.551,207.016c0.01,0.03,0.036-0.001,0.038-0.019c0.015-0.127,0.003-0.295,0.153-0.332 c0.12-0.029,0.277,0.076,0.375,0.136c0.041,0.025,0.068-0.043,0.07-0.07c0.008-0.082,0.043-0.344,0.124-0.397 c0.119-0.079,0.293,0.169,0.355,0.243c0.051,0.062,0.108-0.003,0.106-0.066c-0.005-0.206,0.11-0.697,0.392-0.653 c0.066,0.01,0.125,0.043,0.177,0.088c-0.012,0.306,0.07,0.626,0.318,0.787c0.069,0.045,0.108-0.038,0.115-0.093 c0.028-0.245-0.075-0.613-0.273-0.848c0.027-0.189,0.101-0.362,0.22-0.448c0.171-0.122,0.305,0.015,0.48-0.008 c0.113-0.015,0.163-0.11,0.194-0.21c0.221,0.151,0.367-0.084,0.472-0.297c0.283,0.216,0.511-0.026,0.577-0.319 c0.126,0.096,0.282,0.182,0.43,0.171c0.245-0.018,0.212-0.298,0.181-0.472c-0.014-0.08-0.091-0.014-0.086,0.042 c0.038,0.39-0.406,0.1-0.543-0.037c-0.064-0.064-0.141-0.001-0.137,0.078c0.014,0.271-0.169,0.522-0.419,0.291 c-0.029-0.027-0.077-0.007-0.091,0.025c-0.072,0.167-0.164,0.5-0.387,0.294c-0.045-0.042-0.088,0.019-0.095,0.06 c-0.054,0.333-0.268,0.115-0.488,0.15c-0.206,0.033-0.325,0.229-0.391,0.41c-0.017,0.047-0.032,0.097-0.044,0.15 c-0.079-0.058-0.167-0.098-0.265-0.103c-0.379-0.018-0.446,0.416-0.459,0.743c-0.103-0.125-0.241-0.257-0.381-0.189 c-0.159,0.077-0.166,0.312-0.176,0.488c-0.137-0.088-0.328-0.186-0.469-0.082C310.487,206.634,310.504,206.873,310.551,207.016z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284.771,209.568c0.01,0.03,0.036-0.001,0.038-0.019c0.015-0.127,0.003-0.295,0.153-0.332 c0.12-0.029,0.277,0.077,0.375,0.136c0.041,0.025,0.068-0.043,0.07-0.07c0.008-0.082,0.043-0.344,0.124-0.397 c0.12-0.079,0.294,0.169,0.355,0.243c0.051,0.062,0.108-0.003,0.106-0.066c-0.005-0.206,0.11-0.697,0.392-0.653 c0.065,0.01,0.124,0.043,0.177,0.088c-0.012,0.306,0.07,0.626,0.318,0.787c0.069,0.045,0.108-0.038,0.115-0.093 c0.028-0.245-0.075-0.614-0.272-0.849c0.027-0.189,0.101-0.362,0.22-0.447c0.171-0.122,0.305,0.015,0.48-0.008 c0.113-0.015,0.164-0.11,0.194-0.21c0.221,0.151,0.367-0.084,0.472-0.296c0.283,0.216,0.511-0.026,0.577-0.319 c0.126,0.096,0.282,0.182,0.43,0.171c0.245-0.018,0.211-0.298,0.181-0.472c-0.014-0.08-0.091-0.014-0.086,0.042 c0.038,0.39-0.406,0.099-0.543-0.037c-0.064-0.064-0.141-0.001-0.137,0.079c0.014,0.271-0.169,0.522-0.419,0.291 c-0.029-0.027-0.077-0.007-0.091,0.025c-0.073,0.167-0.164,0.5-0.387,0.294c-0.045-0.042-0.088,0.019-0.095,0.06 c-0.054,0.333-0.268,0.115-0.488,0.15c-0.206,0.033-0.325,0.229-0.391,0.41c-0.017,0.047-0.032,0.097-0.044,0.15 c-0.079-0.058-0.166-0.098-0.265-0.103c-0.379-0.019-0.446,0.416-0.459,0.743c-0.103-0.125-0.241-0.257-0.381-0.189 c-0.159,0.077-0.166,0.312-0.176,0.488c-0.137-0.088-0.328-0.186-0.469-0.082C284.707,209.185,284.724,209.425,284.771,209.568z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M310.111,207.197c0.014,0.014,0.031,0.004,0.04-0.011c0.006-0.01,0.01-0.015,0.014-0.02 c0.004-0.005,0.008-0.01,0.012-0.015c0.008-0.012-0.006,0.006,0.004-0.005c0.009-0.01,0.018-0.021,0.028-0.029 c0.006-0.004,0.012-0.008,0.018-0.012c0.003-0.002,0.006-0.003,0.008-0.004c0.004-0.002-0.005,0.002,0.002-0.001 c0.013-0.005,0.026-0.008,0.04-0.01c0.008-0.001-0.002,0,0.003,0c0.003,0,0.007,0,0.01,0c0.007,0,0.015,0.001,0.022,0.002 c0.008,0.001,0.015,0.003,0.022,0.005c0.004,0.001,0.007,0.002,0.01,0.003c0.003,0.001,0.003,0.001,0,0 c0.001,0.001,0.003,0.001,0.004,0.001c0.035,0.015,0.068,0.036,0.098,0.059c0.01,0.008,0.027,0.003,0.035-0.003 c0.012-0.009,0.022-0.026,0.026-0.04c0.008-0.03,0.007-0.071-0.021-0.09c-0.063-0.043-0.143-0.077-0.22-0.057 c-0.079,0.02-0.135,0.092-0.16,0.167C310.1,207.157,310.095,207.183,310.111,207.197z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M309.478,207.874c0.002,0.022,0.021,0.004,0.022-0.009c0.012-0.141,0.025-0.294,0.144-0.382 c0.097-0.073,0.237-0.086,0.353-0.11c0.102-0.021,0.203-0.046,0.302-0.078c0.051-0.017,0.053-0.147-0.004-0.128 c-0.169,0.055-0.345,0.078-0.516,0.126c-0.058,0.016-0.117,0.038-0.165,0.076c-0.061,0.047-0.095,0.122-0.115,0.194 C309.472,207.663,309.472,207.771,309.478,207.874z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M301.221,212.196c0.028,0.04,0.078,0.032,0.094-0.016c0.127-0.388,0.438-0.35,0.627-0.001 c0.036,0.066,0.083-0.017,0.082-0.058c-0.006-0.272,0.029-0.651,0.182-0.885c0.196-0.301,0.327,0.06,0.548,0.052 c0.213-0.008,0.272-0.253,0.287-0.461c0.189,0.117,0.373-0.01,0.46-0.248c0.227,0.197,0.401,0.059,0.503-0.216 c0.118,0.102,0.28,0.288,0.394,0.258c0.217-0.058,0.25-1.182,0.578-0.508c0.016,0.033,0.035,0.049,0.053,0.053 c0.004,0.05,0.025,0.101,0.055,0.12c0.324,0.203,0.584,0.141,0.743-0.213c0.166-0.368,0.296-1.697,0.877-0.852 c0.045,0.065,0.115,0.006,0.118-0.055c0.012-0.287,0.03-0.674,0.369-0.337c0.048,0.048,0.1-0.029,0.103-0.071 c0.011-0.192,0.006-0.672,0.319-0.449c0.154,0.11,0.262,0.314,0.3,0.496c0.019,0.091,0.111,0.012,0.099-0.054 c-0.066-0.36,0.044-0.703,0.224-1.013c0.031-0.053-0.018-0.154-0.066-0.078c-0.152,0.242-0.258,0.497-0.281,0.767 c-0.106-0.206-0.268-0.407-0.46-0.379c-0.218,0.032-0.254,0.295-0.268,0.505c-0.345-0.285-0.438,0.018-0.469,0.375 c-0.221-0.242-0.493-0.309-0.718,0.045c-0.077,0.122-0.123,0.338-0.176,0.552c-0.014-0.136-0.069-0.264-0.172-0.362 c-0.349-0.33-0.57,0.204-0.644,0.598c-0.128-0.161-0.294-0.243-0.45,0.01c-0.064,0.104-0.151,0.572-0.201,0.575 c-0.031,0.002-0.297-0.248-0.346-0.273c-0.055-0.028-0.097,0.009-0.112,0.064c-0.009,0.22-0.133,0.268-0.372,0.145 c-0.048-0.059-0.121-0.018-0.133,0.047c0,0.194-0.116,0.262-0.347,0.203c-0.06-0.083-0.156-0.049-0.155,0.055 c0.001,0.081,0.021,0.258-0.027,0.323c-0.124,0.167-0.232,0.001-0.336-0.046c-0.148-0.066-0.279,0.01-0.374,0.128 c-0.199,0.25-0.216,0.61-0.206,0.935c-0.224-0.313-0.589-0.34-0.692,0.064c-0.411-0.397-0.727-0.997-0.915-1.522 c-0.038-0.107-0.132-0.018-0.129,0.059C300.221,211.225,300.853,211.674,301.221,212.196z M305.342,209.369 c0.279-0.211,0.296,0.314,0.208,0.469c-0.095,0.166-0.237,0.241-0.424,0.207c0.001-0.007,0.002-0.013,0.001-0.02 C305.115,209.842,305.186,209.487,305.342,209.369z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M300.677,195.05c0.181-0.011,0.383-0.08,0.522-0.207c0.229,0.229,0.509,0.435,0.649,0.63 c0.066,0.092,0.131-0.035,0.127-0.098c-0.012-0.204,0.109-0.453,0.255-0.591c0.147-0.139,0.253-0.101,0.429-0.067 c0.201,0.039,0.272-0.066,0.278-0.217c0.262,0.105,0.403-0.171,0.483-0.427c0.118,0.099,0.255,0.17,0.404,0.073 c0.153-0.099,0.232-0.304,0.298-0.473c0.216,0.148,0.318,0.57,0.641,0.502c0.264-0.055,0.47-0.43,0.523-0.67 c0.015-0.066-0.052-0.078-0.068-0.013c-0.055,0.23-0.33,0.664-0.612,0.527c-0.218-0.106-0.265-0.402-0.481-0.514 c-0.023-0.012-0.049,0.008-0.058,0.029c-0.129,0.304-0.294,0.682-0.64,0.345c-0.038-0.037-0.074,0.012-0.084,0.046 c-0.06,0.212-0.169,0.563-0.446,0.361c-0.065-0.048-0.099,0.053-0.091,0.104c0.037,0.236-0.165,0.115-0.3,0.093 c-0.12-0.019-0.218,0.013-0.315,0.086c-0.18,0.136-0.313,0.363-0.359,0.594c-0.113-0.118-0.246-0.222-0.363-0.332 c-0.042-0.04-0.097-0.089-0.154-0.144c0.013-0.026,0.024-0.052,0.032-0.08c0.078-0.287-0.088-0.621-0.39-0.677 c-0.043-0.008-0.067,0.02-0.081,0.058c-0.097,0.26,0.007,0.491,0.18,0.701c-0.127,0.075-0.279,0.083-0.405,0.158 C300.593,194.882,300.583,195.056,300.677,195.05z M301.006,194.171c0.168,0.061,0.249,0.234,0.182,0.38 C301.085,194.432,301.003,194.299,301.006,194.171z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M296.111,198.8c0.01,0.03,0.036-0.001,0.038-0.019c0.015-0.127,0.003-0.295,0.153-0.332 c0.12-0.029,0.277,0.076,0.375,0.136c0.041,0.025,0.068-0.043,0.07-0.07c0.008-0.082,0.043-0.344,0.124-0.397 c0.119-0.079,0.293,0.169,0.355,0.243c0.051,0.062,0.108-0.003,0.106-0.065c-0.005-0.206,0.11-0.697,0.392-0.653 c0.066,0.01,0.125,0.043,0.177,0.088c-0.012,0.306,0.07,0.626,0.318,0.787c0.069,0.045,0.108-0.038,0.115-0.093 c0.028-0.245-0.075-0.613-0.273-0.848c0.027-0.189,0.101-0.362,0.22-0.448c0.171-0.122,0.305,0.015,0.48-0.008 c0.113-0.015,0.163-0.11,0.194-0.21c0.221,0.151,0.367-0.084,0.472-0.296c0.283,0.216,0.511-0.026,0.577-0.319 c0.126,0.096,0.282,0.182,0.43,0.171c0.245-0.018,0.211-0.298,0.181-0.472c-0.014-0.08-0.091-0.014-0.086,0.042 c0.038,0.39-0.407,0.099-0.543-0.037c-0.064-0.064-0.141-0.001-0.137,0.078c0.014,0.271-0.169,0.522-0.419,0.291 c-0.029-0.027-0.077-0.007-0.091,0.025c-0.073,0.167-0.164,0.5-0.387,0.294c-0.045-0.042-0.088,0.019-0.095,0.06 c-0.055,0.333-0.268,0.115-0.488,0.15c-0.206,0.033-0.325,0.229-0.391,0.41c-0.017,0.047-0.032,0.097-0.044,0.15 c-0.079-0.058-0.166-0.098-0.265-0.103c-0.379-0.019-0.446,0.416-0.459,0.742c-0.103-0.125-0.241-0.257-0.382-0.189 c-0.158,0.077-0.166,0.312-0.175,0.488c-0.137-0.088-0.329-0.186-0.469-0.082C296.047,198.417,296.064,198.657,296.111,198.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M294.941,199.495c0.001,0.022,0.021,0.004,0.022-0.009c0.012-0.141,0.025-0.294,0.144-0.382 c0.097-0.073,0.237-0.086,0.353-0.11c0.102-0.021,0.203-0.046,0.302-0.078c0.051-0.017,0.053-0.147-0.004-0.128 c-0.169,0.055-0.345,0.078-0.516,0.126c-0.058,0.016-0.117,0.039-0.165,0.076c-0.061,0.047-0.095,0.122-0.115,0.194 C294.934,199.284,294.934,199.392,294.941,199.495z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.05,204.728c0.028,0.04,0.078,0.032,0.094-0.016c0.127-0.388,0.438-0.35,0.627,0 c0.036,0.066,0.083-0.017,0.082-0.058c-0.006-0.272,0.029-0.651,0.182-0.886c0.197-0.301,0.327,0.06,0.548,0.052 c0.213-0.008,0.272-0.253,0.288-0.462c0.189,0.117,0.373-0.01,0.46-0.248c0.227,0.197,0.401,0.059,0.503-0.216 c0.118,0.102,0.281,0.288,0.394,0.258c0.217-0.058,0.25-1.182,0.578-0.509c0.016,0.033,0.034,0.049,0.053,0.053 c0.005,0.05,0.025,0.101,0.056,0.12c0.324,0.203,0.583,0.141,0.743-0.213c0.166-0.368,0.296-1.697,0.877-0.852 c0.045,0.065,0.116,0.006,0.118-0.055c0.012-0.287,0.031-0.674,0.369-0.336c0.048,0.048,0.1-0.029,0.103-0.071 c0.011-0.192,0.006-0.672,0.319-0.449c0.154,0.11,0.262,0.314,0.3,0.496c0.019,0.091,0.111,0.012,0.099-0.054 c-0.066-0.36,0.044-0.703,0.224-1.013c0.031-0.053-0.018-0.154-0.066-0.078c-0.152,0.242-0.258,0.497-0.281,0.767 c-0.106-0.206-0.268-0.407-0.46-0.379c-0.218,0.032-0.254,0.295-0.268,0.505c-0.345-0.285-0.438,0.018-0.469,0.375 c-0.221-0.242-0.493-0.309-0.718,0.045c-0.077,0.122-0.123,0.338-0.176,0.552c-0.014-0.136-0.069-0.264-0.172-0.362 c-0.349-0.329-0.57,0.204-0.644,0.598c-0.128-0.161-0.294-0.243-0.45,0.01c-0.064,0.104-0.15,0.572-0.201,0.575 c-0.031,0.002-0.297-0.248-0.346-0.273c-0.055-0.028-0.097,0.009-0.112,0.064c-0.009,0.22-0.133,0.268-0.372,0.145 c-0.048-0.058-0.121-0.018-0.133,0.047c0,0.194-0.116,0.262-0.347,0.203c-0.06-0.083-0.156-0.049-0.155,0.055 c0.001,0.081,0.021,0.258-0.027,0.323c-0.124,0.167-0.232,0.001-0.336-0.046c-0.148-0.066-0.279,0.01-0.374,0.129 c-0.199,0.25-0.216,0.61-0.206,0.935c-0.224-0.313-0.59-0.34-0.692,0.064c-0.411-0.397-0.727-0.997-0.915-1.522 c-0.038-0.107-0.132-0.017-0.129,0.059C285.051,203.757,285.682,204.206,286.05,204.728z M290.172,201.901 c0.279-0.211,0.296,0.314,0.208,0.469c-0.095,0.166-0.237,0.241-0.424,0.207c0.001-0.007,0.002-0.013,0.001-0.02 C289.944,202.374,290.015,202.019,290.172,201.901z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M286.865,216.744c0.028,0.04,0.078,0.033,0.094-0.016c0.126-0.388,0.438-0.35,0.627,0 c0.036,0.066,0.083-0.017,0.082-0.058c-0.006-0.272,0.029-0.651,0.182-0.886c0.196-0.301,0.327,0.06,0.548,0.052 c0.213-0.008,0.272-0.253,0.288-0.461c0.189,0.116,0.373-0.01,0.46-0.248c0.227,0.197,0.401,0.059,0.503-0.216 c0.118,0.102,0.281,0.288,0.394,0.258c0.217-0.058,0.249-1.182,0.578-0.508c0.016,0.033,0.035,0.049,0.053,0.053 c0.005,0.05,0.025,0.101,0.055,0.12c0.324,0.203,0.584,0.141,0.743-0.213c0.166-0.368,0.296-1.697,0.877-0.852 c0.045,0.065,0.116,0.006,0.118-0.055c0.012-0.287,0.03-0.674,0.369-0.336c0.048,0.048,0.1-0.029,0.103-0.071 c0.011-0.192,0.006-0.672,0.319-0.449c0.154,0.11,0.262,0.314,0.3,0.496c0.019,0.091,0.111,0.013,0.099-0.054 c-0.066-0.36,0.044-0.703,0.224-1.013c0.031-0.053-0.018-0.154-0.066-0.078c-0.152,0.242-0.258,0.497-0.281,0.766 c-0.106-0.206-0.268-0.407-0.46-0.379c-0.218,0.032-0.254,0.295-0.268,0.505c-0.345-0.285-0.438,0.018-0.469,0.375 c-0.221-0.242-0.493-0.309-0.718,0.045c-0.077,0.122-0.123,0.338-0.177,0.552c-0.014-0.135-0.069-0.264-0.172-0.362 c-0.349-0.33-0.57,0.204-0.644,0.598c-0.127-0.161-0.294-0.243-0.449,0.01c-0.064,0.104-0.151,0.572-0.201,0.575 c-0.031,0.002-0.297-0.248-0.346-0.273c-0.055-0.028-0.097,0.009-0.112,0.064c-0.009,0.22-0.133,0.268-0.372,0.145 c-0.048-0.059-0.121-0.018-0.133,0.047c0,0.194-0.115,0.262-0.347,0.203c-0.06-0.083-0.156-0.049-0.155,0.055 c0.001,0.081,0.021,0.258-0.027,0.323c-0.124,0.167-0.232,0.001-0.336-0.046c-0.148-0.066-0.279,0.01-0.374,0.129 c-0.199,0.25-0.216,0.61-0.206,0.935c-0.224-0.313-0.589-0.34-0.692,0.064c-0.411-0.397-0.727-0.997-0.915-1.522 c-0.038-0.107-0.132-0.017-0.129,0.059C285.866,215.773,286.497,216.222,286.865,216.744z M290.987,213.917 c0.279-0.211,0.296,0.314,0.208,0.469c-0.095,0.166-0.237,0.241-0.424,0.207c0.001-0.007,0.002-0.013,0.001-0.02 C290.759,214.39,290.83,214.035,290.987,213.917z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M308.019,202.888c0.158,0.731,0.572,1.49,1.076,2.04c0.051,0.055,0.147,0.082,0.174-0.016 c0.069-0.247-0.034-0.869,0.262-0.962c0.221-0.07,0.348,0.337,0.539,0.451c0.043,0.025,0.083,0.002,0.104-0.038 c0.157-0.299,0.114-0.727,0.303-1.006c0.074,0.107,0.174,0.213,0.299,0.141c0.106-0.061,0.142-0.249,0.165-0.399 c0.251,0.174,0.423-0.023,0.513-0.309c0.283,0.268,0.477,0.073,0.638-0.259c0.108,0.122,0.201,0.241,0.38,0.256 c0.035,0.003,0.064-0.01,0.078-0.044c0.065-0.157,0.082-0.326,0.127-0.488c0.118-0.432,0.366-0.001,0.467,0.187 c0.029,0.055,0.106,0.077,0.136,0.008c0.087-0.203,0.091-0.422,0.137-0.635c0.013-0.062,0.022-0.153,0.056-0.206 c0.075-0.116,0.245-0.142,0.382-0.072c0.118,0.061,0.182,0.303,0.213,0.424c0.028,0.11,0.16,0.096,0.16-0.02 c-0.003-0.379-0.078-1.117,0.34-1.299c0.094-0.041,0.193-0.038,0.278-0.003c-0.107,0.189-0.158,0.396-0.099,0.603 c0.108,0.383,0.466,0.298,0.51-0.066c0.021-0.174-0.04-0.392-0.152-0.562c0.141-0.196,0.326-0.347,0.548-0.456 c0.077-0.038,0.049-0.24-0.042-0.199c-0.213,0.096-0.46,0.277-0.64,0.499c-0.129-0.109-0.291-0.155-0.472-0.068 c-0.369,0.177-0.433,0.673-0.44,1.101c-0.118-0.197-0.291-0.355-0.511-0.273c-0.319,0.119-0.302,0.582-0.364,0.904 c-0.113-0.209-0.288-0.463-0.504-0.321c-0.113,0.074-0.147,0.268-0.177,0.387c-0.013,0.054-0.027,0.283-0.071,0.314 c-0.09,0.065-0.272-0.203-0.319-0.25c-0.039-0.038-0.097-0.038-0.121,0.018c-0.109,0.247-0.249,0.579-0.537,0.222 c-0.049-0.06-0.119-0.016-0.132,0.046c-0.028,0.132-0.104,0.572-0.396,0.266c-0.052-0.055-0.119-0.021-0.133,0.047 c-0.015,0.074-0.061,0.546-0.253,0.244c-0.03-0.047-0.083-0.074-0.128-0.028c-0.267,0.273-0.222,0.699-0.355,1.038 c-0.192-0.183-0.268-0.563-0.604-0.436c-0.369,0.14-0.33,0.549-0.364,0.884c-0.407-0.508-0.648-1.106-0.864-1.721 C308.163,202.653,307.978,202.699,308.019,202.888z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M304.252,207.125c0.142-0.056,0.193-0.193,0.202-0.335c0.119,0.113,0.244,0.292,0.406,0.192 c0.098-0.06,0.134-0.181,0.144-0.304c0.128,0.133,0.29,0.218,0.472,0.074c0.15-0.119,0.135-0.288,0.146-0.454 c0.038,0.059,0.087,0.11,0.151,0.122c0.102,0.019,0.169-0.079,0.21-0.157c0.089-0.171,0.117-0.358,0.164-0.541 c0.157,0.174,0.334,0.378,0.55,0.446c0.324,0.102,0.404-0.325,0.432-0.55c0.017-0.129-0.142-0.205-0.161-0.047 c-0.023,0.193-0.074,0.473-0.32,0.339c-0.19-0.104-0.34-0.29-0.489-0.444c-0.045-0.046-0.096-0.03-0.116,0.031 c-0.052,0.159-0.071,0.328-0.123,0.488c-0.018,0.056-0.048,0.185-0.108,0.214c-0.077,0.038-0.139-0.112-0.163-0.162 c-0.037-0.075-0.098-0.046-0.117,0.024c-0.038,0.141,0.005,0.315-0.058,0.447c-0.048,0.1-0.18,0.149-0.281,0.107 c-0.094-0.038-0.155-0.14-0.211-0.219c-0.065-0.091-0.117,0.042-0.109,0.1c0.015,0.108,0.032,0.419-0.156,0.344 c-0.124-0.049-0.191-0.216-0.308-0.286c-0.057-0.034-0.079,0.075-0.075,0.107c0.017,0.14-0.033,0.274-0.106,0.392 C304.214,207.076,304.209,207.142,304.252,207.125z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M293.73,220.729c0.142-0.056,0.193-0.193,0.202-0.335c0.119,0.113,0.244,0.292,0.406,0.192 c0.098-0.06,0.134-0.181,0.144-0.304c0.128,0.133,0.29,0.218,0.472,0.074c0.15-0.119,0.134-0.288,0.146-0.454 c0.038,0.059,0.087,0.11,0.151,0.122c0.102,0.019,0.169-0.078,0.21-0.157c0.089-0.171,0.117-0.358,0.164-0.541 c0.157,0.174,0.334,0.378,0.55,0.446c0.324,0.102,0.404-0.325,0.432-0.55c0.017-0.129-0.142-0.205-0.161-0.048 c-0.023,0.193-0.074,0.473-0.32,0.339c-0.19-0.105-0.34-0.29-0.489-0.444c-0.045-0.046-0.096-0.03-0.116,0.031 c-0.052,0.159-0.071,0.328-0.123,0.488c-0.018,0.057-0.048,0.185-0.108,0.215c-0.077,0.038-0.138-0.112-0.163-0.162 c-0.037-0.075-0.098-0.046-0.117,0.024c-0.038,0.141,0.005,0.315-0.059,0.447c-0.047,0.1-0.18,0.149-0.281,0.107 c-0.094-0.038-0.155-0.14-0.212-0.219c-0.065-0.091-0.117,0.042-0.109,0.1c0.015,0.109,0.032,0.419-0.156,0.344 c-0.124-0.049-0.192-0.216-0.308-0.286c-0.057-0.034-0.079,0.075-0.075,0.107c0.017,0.14-0.033,0.274-0.106,0.392 C293.692,220.68,293.688,220.746,293.73,220.729z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M281.214,211.422c0.142-0.056,0.193-0.193,0.202-0.335c0.119,0.113,0.244,0.292,0.406,0.192 c0.098-0.06,0.133-0.181,0.144-0.304c0.129,0.133,0.291,0.218,0.472,0.074c0.15-0.119,0.134-0.288,0.146-0.453 c0.038,0.059,0.087,0.11,0.151,0.122c0.102,0.019,0.169-0.078,0.21-0.157c0.089-0.171,0.117-0.359,0.164-0.541 c0.157,0.174,0.334,0.378,0.55,0.446c0.324,0.102,0.404-0.325,0.432-0.55c0.016-0.13-0.142-0.205-0.161-0.048 c-0.023,0.193-0.074,0.473-0.32,0.339c-0.19-0.104-0.34-0.29-0.489-0.444c-0.045-0.047-0.096-0.03-0.116,0.031 c-0.052,0.159-0.071,0.328-0.122,0.488c-0.018,0.057-0.048,0.185-0.108,0.214c-0.077,0.038-0.138-0.112-0.163-0.162 c-0.037-0.075-0.098-0.046-0.117,0.024c-0.038,0.141,0.004,0.315-0.059,0.447c-0.047,0.1-0.18,0.149-0.281,0.107 c-0.094-0.038-0.155-0.14-0.212-0.219c-0.065-0.091-0.117,0.042-0.109,0.1c0.015,0.109,0.032,0.419-0.156,0.345 c-0.124-0.049-0.192-0.216-0.308-0.286c-0.057-0.034-0.079,0.075-0.075,0.107c0.017,0.14-0.032,0.274-0.106,0.392 C281.176,211.373,281.171,211.439,281.214,211.422z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M296.144,212.561c0.039,0.057,0.093,0.001,0.094-0.051c0.005-0.287,0.004-0.595,0.091-0.872 c0.051-0.162,0.132-0.323,0.32-0.341c0.184-0.018,0.279,0.131,0.425,0.198c0.431,0.198,0.572-0.36,0.598-0.712 c0.159,0.067,0.294,0.036,0.356-0.106c0.257,0.234,0.445-0.041,0.502-0.34c0.134,0.139,0.258,0.265,0.449,0.082 c0.172-0.164,0.146-0.4,0.163-0.618c0.184,0.182,0.379,0.398,0.644,0.215c0.248-0.171,0.233-0.504,0.273-0.778 c0.145,0.063,0.267,0.162,0.398,0.252c0.02,0.013,0.045-0.005,0.056-0.02c0.055-0.075,0.069-0.138,0.115-0.216 c0.013-0.11,0.071-0.195,0.175-0.255c0.136,0.068,0.254,0.16,0.353,0.275c0.036,0.042,0.087,0.035,0.114-0.012 c0.073-0.128,0.089-0.27,0.152-0.401c0.125-0.26,0.263-0.183,0.465-0.006c0.071,0.062,0.134,0.007,0.15-0.068 c0.037-0.164,0.013-0.35,0.068-0.507c0.17-0.487,0.614,0.054,0.723,0.276c0.044,0.091,0.145,0.042,0.146-0.047 c0.003-0.272-0.167-0.95,0.144-1.062c0.07-0.025,0.059-0.199-0.026-0.175c-0.323,0.095-0.315,0.531-0.295,0.879 c-0.166-0.229-0.411-0.438-0.67-0.317c-0.241,0.112-0.253,0.419-0.277,0.674c-0.14-0.108-0.31-0.199-0.462-0.076 c-0.139,0.112-0.203,0.378-0.241,0.585c-0.133-0.094-0.261-0.185-0.415-0.253c-0.025-0.011-0.049,0.005-0.062,0.025 c-0.072,0.105-0.081,0.21-0.136,0.317c-0.138,0.268-0.284,0.028-0.493-0.05c-0.037-0.014-0.062,0.022-0.07,0.054 c-0.05,0.21-0.024,0.662-0.276,0.753c-0.236,0.086-0.42-0.192-0.56-0.33c-0.046-0.046-0.1-0.031-0.119,0.033 c-0.031,0.106-0.013,0.24-0.048,0.338c-0.038,0.106-0.245,0.29-0.339,0.26c0,0-0.163-0.154-0.127-0.121 c-0.07-0.063-0.109,0.064-0.107,0.11c0.039,0.232-0.079,0.329-0.353,0.291c-0.059-0.07-0.117,0.012-0.115,0.077 c-0.058,0.169-0.151,0.189-0.278,0.059c-0.043-0.036-0.082,0.012-0.09,0.053c-0.031,0.165-0.04,0.331-0.096,0.49 c-0.047,0.135-0.176,0.279-0.349,0.235c-0.056-0.014-0.142-0.128-0.188-0.159c-0.174-0.117-0.386-0.154-0.557-0.012 c-0.288,0.238-0.272,0.74-0.248,1.126c-0.34-0.432-0.783-0.897-0.849-1.445c-0.012-0.104-0.11-0.066-0.116,0.02 C295.111,211.542,295.808,212.074,296.144,212.561z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M301.525,198.029c0.158,0.73,0.572,1.49,1.076,2.039c0.051,0.056,0.147,0.082,0.174-0.016 c0.069-0.247-0.034-0.869,0.262-0.962c0.221-0.07,0.348,0.338,0.539,0.451c0.043,0.025,0.083,0.002,0.104-0.038 c0.157-0.299,0.114-0.727,0.303-1.006c0.074,0.107,0.174,0.213,0.299,0.141c0.106-0.061,0.142-0.249,0.165-0.399 c0.251,0.174,0.423-0.024,0.513-0.309c0.283,0.268,0.478,0.073,0.638-0.259c0.108,0.122,0.2,0.24,0.38,0.255 c0.035,0.003,0.064-0.01,0.079-0.044c0.065-0.157,0.082-0.325,0.127-0.488c0.118-0.432,0.366-0.001,0.467,0.187 c0.029,0.055,0.106,0.077,0.136,0.008c0.087-0.202,0.091-0.422,0.137-0.635c0.014-0.062,0.022-0.153,0.056-0.206 c0.075-0.116,0.245-0.142,0.382-0.072c0.118,0.061,0.182,0.303,0.213,0.424c0.028,0.11,0.16,0.096,0.159-0.02 c-0.003-0.379-0.078-1.117,0.34-1.299c0.094-0.041,0.193-0.038,0.279-0.003c-0.108,0.189-0.158,0.396-0.1,0.603 c0.108,0.383,0.466,0.298,0.51-0.066c0.021-0.174-0.04-0.392-0.152-0.562c0.141-0.196,0.326-0.347,0.548-0.456 c0.077-0.038,0.049-0.241-0.042-0.199c-0.213,0.096-0.46,0.277-0.639,0.499c-0.129-0.109-0.291-0.155-0.472-0.068 c-0.369,0.177-0.433,0.673-0.44,1.101c-0.118-0.197-0.291-0.355-0.511-0.273c-0.319,0.119-0.302,0.582-0.364,0.903 c-0.113-0.209-0.288-0.463-0.504-0.321c-0.113,0.074-0.147,0.268-0.177,0.387c-0.013,0.054-0.027,0.283-0.071,0.314 c-0.09,0.065-0.272-0.203-0.319-0.25c-0.039-0.038-0.097-0.038-0.121,0.018c-0.109,0.247-0.249,0.579-0.537,0.222 c-0.049-0.06-0.119-0.016-0.132,0.046c-0.028,0.132-0.104,0.572-0.396,0.266c-0.052-0.055-0.119-0.021-0.133,0.047 c-0.015,0.074-0.061,0.546-0.253,0.244c-0.03-0.047-0.083-0.074-0.128-0.028c-0.267,0.274-0.222,0.699-0.355,1.038 c-0.192-0.182-0.268-0.563-0.604-0.436c-0.369,0.14-0.329,0.549-0.364,0.884c-0.407-0.508-0.648-1.106-0.864-1.721 C301.669,197.793,301.484,197.839,301.525,198.029z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M281.996,213.517c0.158,0.731,0.572,1.49,1.076,2.039c0.051,0.056,0.147,0.082,0.174-0.016 c0.069-0.247-0.034-0.869,0.262-0.962c0.221-0.07,0.348,0.337,0.539,0.451c0.043,0.025,0.083,0.002,0.104-0.038 c0.157-0.299,0.114-0.727,0.303-1.006c0.074,0.107,0.174,0.213,0.299,0.141c0.106-0.061,0.142-0.249,0.165-0.399 c0.251,0.174,0.423-0.024,0.513-0.309c0.283,0.268,0.477,0.073,0.638-0.259c0.108,0.122,0.2,0.24,0.38,0.255 c0.035,0.003,0.064-0.01,0.079-0.044c0.065-0.157,0.082-0.325,0.127-0.488c0.118-0.432,0.366-0.001,0.467,0.187 c0.029,0.055,0.106,0.077,0.136,0.008c0.087-0.202,0.091-0.422,0.137-0.635c0.013-0.062,0.022-0.153,0.056-0.206 c0.075-0.116,0.245-0.142,0.382-0.072c0.118,0.061,0.182,0.303,0.213,0.424c0.028,0.11,0.16,0.096,0.16-0.02 c-0.003-0.379-0.078-1.117,0.34-1.299c0.094-0.041,0.193-0.038,0.278-0.003c-0.107,0.189-0.158,0.396-0.1,0.603 c0.108,0.383,0.466,0.298,0.51-0.066c0.021-0.174-0.04-0.392-0.152-0.562c0.141-0.196,0.326-0.347,0.548-0.456 c0.077-0.038,0.049-0.24-0.042-0.199c-0.213,0.096-0.46,0.277-0.64,0.499c-0.129-0.109-0.291-0.155-0.472-0.068 c-0.369,0.177-0.433,0.673-0.44,1.101c-0.118-0.197-0.291-0.355-0.511-0.273c-0.319,0.119-0.302,0.582-0.364,0.904 c-0.113-0.209-0.288-0.463-0.504-0.321c-0.113,0.074-0.147,0.268-0.177,0.387c-0.013,0.054-0.027,0.283-0.07,0.314 c-0.09,0.065-0.272-0.203-0.319-0.25c-0.039-0.038-0.097-0.038-0.122,0.017c-0.109,0.247-0.249,0.579-0.537,0.222 c-0.049-0.06-0.119-0.016-0.132,0.046c-0.028,0.132-0.104,0.572-0.396,0.266c-0.052-0.055-0.119-0.021-0.133,0.047 c-0.015,0.074-0.061,0.546-0.253,0.244c-0.03-0.047-0.083-0.074-0.128-0.028c-0.267,0.273-0.222,0.699-0.355,1.038 c-0.192-0.183-0.268-0.563-0.604-0.436c-0.369,0.14-0.33,0.549-0.364,0.884c-0.407-0.508-0.648-1.106-0.864-1.721 C282.14,213.281,281.955,213.327,281.996,213.517z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M297.925,201.427c0.142-0.056,0.193-0.193,0.202-0.335c0.119,0.113,0.244,0.292,0.406,0.192 c0.098-0.06,0.134-0.181,0.144-0.304c0.128,0.133,0.29,0.218,0.472,0.074c0.15-0.119,0.135-0.288,0.146-0.454 c0.038,0.059,0.087,0.11,0.151,0.122c0.102,0.019,0.169-0.078,0.21-0.157c0.089-0.171,0.117-0.359,0.164-0.541 c0.157,0.174,0.334,0.378,0.55,0.446c0.324,0.102,0.404-0.325,0.432-0.55c0.017-0.129-0.142-0.205-0.161-0.048 c-0.023,0.193-0.074,0.473-0.32,0.339c-0.19-0.104-0.34-0.29-0.489-0.444c-0.045-0.046-0.096-0.03-0.116,0.031 c-0.052,0.159-0.071,0.328-0.122,0.488c-0.018,0.057-0.048,0.185-0.108,0.214c-0.077,0.038-0.138-0.112-0.163-0.162 c-0.037-0.075-0.098-0.046-0.117,0.024c-0.038,0.141,0.005,0.315-0.059,0.447c-0.047,0.1-0.18,0.149-0.281,0.107 c-0.094-0.039-0.155-0.14-0.211-0.219c-0.065-0.091-0.117,0.042-0.109,0.1c0.015,0.108,0.032,0.419-0.156,0.344 c-0.124-0.049-0.192-0.216-0.308-0.286c-0.057-0.034-0.079,0.075-0.075,0.107c0.017,0.14-0.033,0.274-0.106,0.392 C297.887,201.378,297.882,201.443,297.925,201.427z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M290.287,206.807c0.039,0.057,0.093,0.001,0.094-0.051c0.005-0.287,0.004-0.595,0.091-0.872 c0.051-0.162,0.132-0.322,0.32-0.341c0.184-0.018,0.279,0.131,0.425,0.198c0.431,0.198,0.572-0.36,0.598-0.712 c0.159,0.068,0.294,0.036,0.356-0.106c0.257,0.234,0.445-0.041,0.502-0.34c0.134,0.139,0.258,0.265,0.449,0.082 c0.172-0.164,0.146-0.399,0.163-0.618c0.184,0.182,0.379,0.398,0.644,0.215c0.248-0.171,0.232-0.505,0.273-0.778 c0.145,0.063,0.267,0.162,0.398,0.252c0.02,0.013,0.045-0.005,0.056-0.02c0.055-0.076,0.069-0.138,0.115-0.216 c0.013-0.11,0.071-0.195,0.175-0.255c0.136,0.068,0.254,0.16,0.353,0.275c0.036,0.042,0.087,0.035,0.114-0.012 c0.073-0.128,0.089-0.27,0.152-0.401c0.125-0.26,0.263-0.183,0.465-0.006c0.071,0.062,0.134,0.007,0.15-0.068 c0.037-0.164,0.013-0.35,0.068-0.507c0.17-0.487,0.614,0.053,0.723,0.276c0.044,0.091,0.145,0.042,0.146-0.047 c0.003-0.271-0.167-0.95,0.144-1.062c0.07-0.025,0.059-0.199-0.026-0.175c-0.323,0.095-0.315,0.531-0.295,0.879 c-0.166-0.229-0.411-0.438-0.67-0.317c-0.241,0.112-0.253,0.419-0.277,0.674c-0.14-0.108-0.31-0.199-0.462-0.076 c-0.139,0.112-0.203,0.378-0.241,0.585c-0.133-0.094-0.261-0.185-0.415-0.253c-0.025-0.011-0.049,0.006-0.062,0.026 c-0.072,0.104-0.08,0.21-0.136,0.317c-0.138,0.269-0.284,0.028-0.493-0.05c-0.037-0.014-0.062,0.022-0.07,0.054 c-0.05,0.21-0.024,0.662-0.275,0.754c-0.236,0.086-0.421-0.193-0.56-0.33c-0.046-0.046-0.1-0.031-0.119,0.033 c-0.031,0.106-0.013,0.24-0.048,0.338c-0.038,0.105-0.245,0.29-0.34,0.26c0,0-0.163-0.154-0.127-0.121 c-0.07-0.063-0.109,0.064-0.108,0.11c0.039,0.232-0.079,0.329-0.352,0.291c-0.059-0.07-0.118,0.012-0.115,0.077 c-0.058,0.169-0.151,0.189-0.278,0.059c-0.043-0.036-0.082,0.012-0.09,0.053c-0.031,0.165-0.04,0.331-0.096,0.49 c-0.047,0.135-0.176,0.279-0.349,0.235c-0.056-0.014-0.142-0.128-0.189-0.159c-0.173-0.117-0.386-0.154-0.557-0.012 c-0.288,0.238-0.272,0.74-0.248,1.126c-0.34-0.432-0.783-0.896-0.849-1.445c-0.013-0.104-0.11-0.066-0.116,0.02 C289.254,205.788,289.951,206.32,290.287,206.807z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5427_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M284.911,172.25c-1.514-1.335-3.633-2.177-5.858-2.7c-5.726,0.083-9.299,1.617-14.461,4.093 l-38.653,16.979l2.095,21.313c4.85-1.918,25.143-13.639,35.168-19.089c4.445-2.417,8.061-3.758,9.523-3.598 c4.532,0.493,7.738,2.395,13.409,1.902C295.666,190.319,289.959,176.701,284.911,172.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5428_",
    style: {
      fill: "#F28F8F"
    },
    d: "M279.206,179.219l5.356,11.992c0,0-0.671-0.131-1.259-0.044 c0,0-2.255-3.964-3.505-6.139c-1.144-1.99-2.459-4.552-2.459-4.552s-4.192-2.636-5.34-4.99 C270.85,173.13,279.206,179.219,279.206,179.219z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_426_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5408_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5420_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5423_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5424_",
    style: {
      fill: "#263238"
    },
    d: "M292.114,201.064c-0.129,0.017-0.258-0.054-0.309-0.18l-1.061-2.629 c-0.06-0.15,0.013-0.321,0.162-0.381c0.153-0.055,0.321,0.013,0.382,0.162l1.061,2.629c0.06,0.15-0.013,0.321-0.162,0.381 C292.162,201.055,292.138,201.061,292.114,201.064z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5411_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5418_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5419_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M286.104,194.646l4.387,4.695c0.644,0.69,1.797,0.169,1.705-0.771 l-0.631-6.445L286.104,194.646z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5416_",
    style: {
      opacity: 0.2
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5417_",
    d: "M286.104,194.646l4.387,4.695c0.644,0.69,1.797,0.169,1.705-0.771l-0.631-6.445L286.104,194.646z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5414_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5415_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M276.322,158.267c-0.303-0.547-0.909-0.727-1.616-0.658 c-1.891,0.171-4.467,2.125-3.655,3.586l15.056,33.449c0.814,0.512,2.369,0.337,3.635-0.396 c0.832-0.478,1.541-1.2,1.824-2.123L276.322,158.267z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5412_",
    style: {
      opacity: 0.5
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5413_",
    d: "M276.322,158.267c-0.303-0.547-0.909-0.727-1.616-0.658c-1.891,0.171-4.467,2.125-3.655,3.586 l15.056,33.449c0.814,0.512,2.369,0.337,3.635-0.396c0.832-0.478,1.541-1.2,1.824-2.123L276.322,158.267z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5409_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5410_",
    style: {
      fill: "#37474F"
    },
    d: "M273.322,155.823c-0.284-0.644-1.037-0.936-1.681-0.652 c-0.644,0.284-0.936,1.037-0.652,1.681l1.21,2.681l0,0c0.076,0.172,0.266,0.295,0.552,0.326 c0.572,0.062,1.31-0.264,1.65-0.728c0.17-0.232,0.208-0.455,0.132-0.627l0,0L273.322,155.823z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5407_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M281.784,170.399c1.422-0.031,2.667,0.177,3.04,0.241 c1.649,0.284,2.899,0.663,4.255,1.527c0.489,0.312,0.956,0.693,1.228,1.206c0.277,0.524,0.326,1.134,0.408,1.721 c0.429,3.065,2.433,5.609,2.869,8.646c0.386,2.689-0.779,9.391-3.059,10.07c-1.419,0.423-2.322-2.807-2.271-4.882 c-0.958,1.17-2.64-0.289-2.665-3.701c-0.021-2.819,0.132-6.419,0.132-6.419L281.784,170.399z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5229_",
    style: {
      fill: "#F28F8F"
    },
    d: "M287.226,176.71c0,0,0.514,0.822-0.091,1.831 c-0.605,1.009-1.459,1.511-1.459,1.511l0.046-1.242L287.226,176.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2148_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M264.592,173.643c4.21-1.966,7.883-3.533,10.933-2.966 c4.091,0.76,4.547,2.088,8.906,3.741c6.193,2.348,1.057,6.168-4.561,4.956c-5.618-1.212-7.871-3.889-7.871-3.889 S264.144,180.191,264.592,173.643z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_484_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_501_",
    style: {
      fill: "#b8a7fc"
    },
    points: "226.938,293.728 302.735,249.966 254.31,222.008 178.514,265.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_499_",
    style: {
      opacity: 0.15
    },
    points: "226.938,293.728 302.735,249.966 254.31,222.008 178.514,265.77  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_491_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_498_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M263.831,271.267l-0.012-1.354c-0.014-1.67,2.974-6.434,6.693-8.581 l30.112-17.38v6.073L263.831,271.267z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_496_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M300.623,243.951l-30.11,17.383c-3.721,2.143-6.708,6.912-6.694,8.578 l0.014,1.355l-46.32-26.743l-0.002,0.001l-0.012-1.354c-0.014-1.67,2.974-6.434,6.692-8.581l30.097-17.372l0.014-0.01 L300.623,243.951z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_494_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M300.623,243.951l-30.11,17.383c-3.721,2.143-6.708,6.912-6.694,8.578 l0.014,1.355l-46.32-26.743l-0.002,0.001l-0.012-1.354c-0.014-1.67,2.974-6.434,6.692-8.581l30.111-17.382L300.623,243.951z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M263.82,270.009l-2.884-1.671l-3.8-2.199c2.128-0.244,3.637,0.077,4.678,0.678 C263.2,267.61,263.747,268.902,263.82,270.009z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.82,270.009l-2.884-1.671l-3.8-2.199c2.128-0.244,3.637,0.077,4.678,0.678 C263.2,267.61,263.747,268.902,263.82,270.009z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_489_",
    style: {
      fill: "#b8a7fc"
    },
    points: "226.948,294.99 226.938,293.728 178.513,265.77 178.514,267.026  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_487_",
    style: {
      opacity: 0.3
    },
    points: "226.948,294.99 226.938,293.728 178.513,265.77 178.514,267.026  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_485_",
    style: {
      fill: "#b8a7fc"
    },
    points: "226.948,294.99 302.745,251.228 302.735,249.967 226.938,293.728  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M263.82,270.009c-0.014-1.67-3.062-3.06-6.788-0.925l-30.099,17.246v6.239 l36.898-21.302C263.831,271.267,263.835,271.679,263.82,270.009z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_482_",
    style: {
      fill: "#EBEBEB"
    },
    points: "226.933,292.569 226.933,286.33 180.613,259.587 180.614,265.826  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M257.036,269.085l-1.349,0.771l-28.753,16.473l-40.916-23.623l-5.404-3.12 l30.102-17.245c2.73-1.566,4.256-1.441,5.329-0.833l0,0L263,268.618C261.305,267.662,259.328,267.861,257.036,269.085z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_443_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_461_",
    style: {
      fill: "#E0E0E0"
    },
    points: "224.828,281.629 250.461,266.839 251.81,266.068 252.797,266.637  251.448,267.408 225.814,282.199  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_460_",
    style: {
      fill: "#E0E0E0"
    },
    points: "222.461,280.263 248.094,265.472 249.443,264.701 250.43,265.27  249.081,266.042 223.447,280.832  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_459_",
    style: {
      fill: "#E0E0E0"
    },
    points: "220.094,278.896 245.727,264.106 247.076,263.334 248.063,263.904  246.713,264.675 221.08,279.466  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_458_",
    style: {
      fill: "#E0E0E0"
    },
    points: "217.727,277.529 243.36,262.739 244.709,261.968 245.695,262.537  244.346,263.308 218.713,278.099  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_457_",
    style: {
      fill: "#E0E0E0"
    },
    points: "215.359,276.163 240.993,261.372 242.342,260.601 243.328,261.17  241.979,261.942 216.346,276.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_456_",
    style: {
      fill: "#E0E0E0"
    },
    points: "212.992,274.796 238.626,260.006 239.975,259.234 240.961,259.804  239.612,260.575 213.979,275.366  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_455_",
    style: {
      fill: "#E0E0E0"
    },
    points: "210.625,273.429 236.258,258.639 237.608,257.868 238.594,258.437  237.245,259.208 211.611,273.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_454_",
    style: {
      fill: "#E0E0E0"
    },
    points: "208.258,272.063 233.891,257.272 235.24,256.501 236.227,257.071  234.878,257.842 209.244,272.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_453_",
    style: {
      fill: "#E0E0E0"
    },
    points: "205.891,270.696 231.524,255.906 232.873,255.134 233.86,255.704  232.511,256.475 206.877,271.266  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_452_",
    style: {
      fill: "#E0E0E0"
    },
    points: "203.524,269.329 229.157,254.539 230.506,253.768 231.493,254.337  230.144,255.109 204.51,269.899  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_451_",
    style: {
      fill: "#E0E0E0"
    },
    points: "201.157,267.963 226.79,253.172 228.139,252.401 229.126,252.971  227.776,253.742 202.143,268.532  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_450_",
    style: {
      fill: "#E0E0E0"
    },
    points: "198.79,266.596 224.423,251.806 225.772,251.035 226.758,251.604  225.409,252.375 199.776,267.166  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_449_",
    style: {
      fill: "#E0E0E0"
    },
    points: "196.422,265.229 222.056,250.439 223.405,249.668 224.391,250.237  223.042,251.009 197.409,265.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_448_",
    style: {
      fill: "#E0E0E0"
    },
    points: "194.055,263.863 219.689,249.072 221.038,248.301 222.024,248.871  220.675,249.642 195.042,264.432  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_447_",
    style: {
      fill: "#E0E0E0"
    },
    points: "191.688,262.496 217.322,247.706 218.671,246.934 219.657,247.504  218.308,248.275 192.675,263.066  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_446_",
    style: {
      fill: "#E0E0E0"
    },
    points: "189.321,261.129 214.954,246.339 216.303,245.568 217.29,246.137  215.941,246.909 190.307,261.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_445_",
    style: {
      fill: "#E0E0E0"
    },
    points: "186.954,259.763 212.587,244.972 213.936,244.201 214.923,244.771  213.574,245.542 187.94,260.332  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    style: {
      opacity: 0.1
    },
    d: "M257.323,267.469c-0.557,0.053-1.737,0.432-2.384,0.579 c-2.738,0.616-7.565,2.82-12.189,5.137c-6.179,3.094-11.999,6.395-11.999,6.395l-42.377-24.439l22.342-12.799 c1.1-0.631,2.001-0.984,2.759-1.145c0.798,0.141,1.433,0.381,1.932,0.665l0.299-0.518c0.117,0.05,0.231,0.105,0.339,0.165 L263,268.618C260.363,267.095,259.135,267.297,257.323,267.469z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_441_",
    style: {
      fill: "#E6E6E6"
    },
    points: "226.903,287.69 231.498,285.358 226.934,288.141 222.347,285.492  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_440_",
    style: {
      fill: "#E6E6E6"
    },
    points: "226.94,290.811 235.362,285.948 226.94,290.482 217.465,285.341  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_438_",
    style: {
      fill: "#E6E6E6"
    },
    points: "180.614,260.964 187.698,265.236 180.614,261.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_437_",
    style: {
      fill: "#E6E6E6"
    },
    points: "180.624,263.401 191.141,269.829 180.614,263.979  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.137,266.139c-0.556,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.189,5.137c-6.179,3.094-11.999,6.395-11.999,6.395l-46.347-26.728c0,0,17.633-10.151,24.552-11.489 c3.247-0.627,5.239-0.189,6.451,0.499l0.005-0.009l46.01,26.564C260.774,266.215,259.265,265.895,257.137,266.139z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_188_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M256.554,263.779c-1.041-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.31 c-1.822,0.41-4.57,1.524-7.566,2.906c-1.507,0.695-3.075,1.456-4.623,2.231c-3.719,1.862-7.306,3.798-9.574,5.046l1.053,0.608 c2.268-1.247,5.855-3.183,9.574-5.045c1.547-0.775,3.116-1.536,4.623-2.231c2.996-1.382,5.745-2.496,7.566-2.906 c0.647-0.147,1.25-0.248,1.807-0.309c2.128-0.244,3.636,0.077,4.678,0.678L256.554,263.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M254.183,262.41c-1.042-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.31 c-1.822,0.41-4.57,1.524-7.566,2.906c-1.507,0.695-3.076,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.575,5.046l1.053,0.608 c2.268-1.247,5.855-3.184,9.574-5.046c1.547-0.775,3.116-1.536,4.623-2.231c2.996-1.381,5.745-2.496,7.566-2.906 c0.647-0.147,1.25-0.248,1.807-0.309c2.128-0.244,3.637,0.077,4.678,0.678L254.183,262.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M251.812,261.041c-1.042-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.309 c-1.821,0.41-4.57,1.525-7.566,2.906c-1.507,0.695-3.075,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.575,5.045l1.053,0.608 c2.268-1.247,5.855-3.183,9.574-5.045c1.547-0.775,3.116-1.536,4.622-2.231c2.996-1.381,5.745-2.496,7.566-2.906 c0.648-0.147,1.25-0.248,1.807-0.31c2.128-0.244,3.636,0.077,4.678,0.678L251.812,261.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M249.441,259.672c-1.041-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.31 c-1.822,0.41-4.57,1.525-7.566,2.906c-1.507,0.695-3.075,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.574,5.046l1.053,0.608 c2.268-1.247,5.855-3.184,9.574-5.046c1.547-0.775,3.116-1.536,4.622-2.231c2.996-1.381,5.745-2.496,7.566-2.906 c0.647-0.147,1.25-0.248,1.806-0.309c2.128-0.244,3.637,0.077,4.678,0.678L249.441,259.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M247.069,258.303c-1.041-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.16,0.163-1.807,0.31 c-1.822,0.41-4.57,1.524-7.566,2.906c-1.507,0.695-3.075,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.574,5.046l1.053,0.608 c2.268-1.247,5.855-3.183,9.574-5.046c1.547-0.775,3.116-1.536,4.622-2.231c2.996-1.381,5.745-2.496,7.566-2.906 c0.647-0.147,1.25-0.248,1.807-0.31c2.128-0.244,3.637,0.077,4.678,0.678L247.069,258.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M244.698,256.934c-1.041-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.309 c-1.822,0.41-4.57,1.525-7.566,2.906c-1.507,0.695-3.076,1.456-4.623,2.231c-3.719,1.862-7.306,3.798-9.574,5.046l1.053,0.608 c2.268-1.247,5.855-3.183,9.574-5.045c1.547-0.775,3.115-1.536,4.622-2.231c2.996-1.381,5.744-2.496,7.566-2.906 c0.647-0.147,1.25-0.248,1.807-0.309c2.128-0.244,3.637,0.076,4.678,0.678L244.698,256.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.327,255.565c-1.042-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.31 c-1.822,0.41-4.57,1.525-7.566,2.906c-1.507,0.695-3.076,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.574,5.045l1.053,0.608 c2.268-1.247,5.855-3.184,9.574-5.046c1.547-0.775,3.116-1.536,4.623-2.231c2.996-1.381,5.744-2.496,7.566-2.906 c0.648-0.147,1.251-0.248,1.807-0.31c2.128-0.244,3.637,0.077,4.678,0.678L242.327,255.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M239.956,254.196c-1.042-0.601-2.55-0.922-4.678-0.678c-0.556,0.062-1.159,0.163-1.807,0.31 c-1.822,0.41-4.57,1.525-7.566,2.906c-1.507,0.695-3.075,1.456-4.622,2.231c-3.719,1.862-7.306,3.798-9.574,5.045l1.053,0.608 c2.268-1.247,5.855-3.184,9.574-5.046c1.547-0.775,3.115-1.536,4.622-2.231c2.996-1.381,5.745-2.496,7.566-2.906 c0.648-0.147,1.25-0.248,1.807-0.309c2.128-0.244,3.637,0.077,4.678,0.678L239.956,254.196z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_431_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M233.959,252.757c-0.556,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.189,5.137c-3.719,1.862-7.306,3.798-9.574,5.045l-1.053-0.608 c2.268-1.247,5.855-3.184,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.648-0.147,1.25-0.248,1.807-0.31 c2.128-0.244,3.637,0.077,4.678,0.678l1.052,0.608C237.595,252.833,236.087,252.513,233.959,252.757z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_424_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_428_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M231.588,251.388c-0.557,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.188,5.137c-3.719,1.862-7.306,3.798-9.575,5.045l-1.053-0.608 c2.268-1.247,5.855-3.183,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.648-0.147,1.25-0.247,1.807-0.309 c2.128-0.244,3.637,0.076,4.678,0.678l1.053,0.608C235.224,251.464,233.716,251.144,231.588,251.388z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_420_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M229.216,250.019c-0.556,0.062-1.159,0.162-1.807,0.309 c-2.738,0.616-7.566,2.82-12.189,5.137c-3.719,1.862-7.306,3.798-9.574,5.046l-1.053-0.608 c2.268-1.247,5.855-3.183,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.647-0.147,1.25-0.248,1.807-0.31 c2.128-0.244,3.636,0.077,4.678,0.678l1.053,0.608C232.853,250.095,231.344,249.775,229.216,250.019z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_273_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M226.845,248.65c-0.556,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.189,5.136c-3.719,1.862-7.306,3.798-9.574,5.046l-1.053-0.608 c2.268-1.247,5.855-3.183,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.648-0.147,1.25-0.248,1.807-0.31 c2.128-0.244,3.637,0.077,4.678,0.678l1.053,0.608C230.482,248.726,228.973,248.406,226.845,248.65z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_266_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M224.474,247.281c-0.557,0.062-1.159,0.163-1.807,0.309 c-2.738,0.616-7.565,2.82-12.189,5.137c-3.719,1.862-7.306,3.798-9.574,5.045l-1.052-0.608 c2.268-1.247,5.855-3.183,9.574-5.045c4.623-2.316,9.451-4.521,12.189-5.137c0.647-0.147,1.25-0.248,1.807-0.309 c2.128-0.244,3.637,0.077,4.678,0.678l1.053,0.608C228.111,247.357,226.602,247.037,224.474,247.281z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_236_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_238_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M222.103,245.911c-0.557,0.062-1.159,0.163-1.807,0.309 c-2.738,0.616-7.565,2.82-12.189,5.137c-3.719,1.862-7.306,3.798-9.574,5.046l-1.053-0.608 c2.268-1.247,5.855-3.183,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.136c0.648-0.147,1.25-0.248,1.807-0.31 c2.128-0.244,3.637,0.077,4.678,0.678l1.053,0.608C225.739,245.988,224.23,245.668,222.103,245.911z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_232_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_234_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M219.732,244.542c-0.557,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.189,5.137c-3.719,1.862-7.306,3.798-9.574,5.045l-1.053-0.608 c2.268-1.247,5.855-3.183,9.574-5.046c4.623-2.316,9.451-4.52,12.189-5.137c0.647-0.147,1.25-0.248,1.806-0.31 c2.128-0.244,3.637,0.077,4.678,0.678l1.053,0.608C223.368,244.619,221.859,244.299,219.732,244.542z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_197_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_201_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M217.36,243.173c-0.556,0.062-1.159,0.163-1.807,0.31 c-2.738,0.616-7.565,2.82-12.189,5.136c-3.719,1.862-7.306,3.798-9.574,5.045l-1.053-0.608 c2.268-1.247,5.855-3.184,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.647-0.147,1.25-0.248,1.807-0.31 c2.128-0.244,3.636,0.077,4.678,0.678l1.053,0.608C220.997,243.25,219.488,242.93,217.36,243.173z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_189_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_193_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M214.989,241.804c-0.556,0.062-1.159,0.163-1.807,0.309 c-2.738,0.616-7.565,2.82-12.188,5.137c-3.719,1.862-7.306,3.798-9.574,5.046l-1.053-0.608 c2.268-1.247,5.855-3.184,9.574-5.046c4.623-2.316,9.451-4.521,12.189-5.137c0.647-0.147,1.25-0.248,1.807-0.309 c2.128-0.244,3.637,0.077,4.678,0.678l1.053,0.608C218.626,241.881,217.117,241.561,214.989,241.804z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M266.179,258.832c-1.392,0.802-2.682,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L266.179,258.832z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M266.179,258.832c-1.392,0.802-2.682,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L266.179,258.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M260.713,261.611l0.385-0.445c1.215-1.407,2.555-2.552,3.875-3.312l27.228-15.686 l1.937,1.118l-27.716,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.305L260.713,261.611z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_148_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M263.811,257.465c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.749-3.208l26.987-15.545l0.963,0.556L263.811,257.465z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M261.442,256.097c-1.392,0.802-2.681,1.971-3.75,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L261.442,256.097z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_144_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M259.074,254.73c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.749-3.208l26.987-15.545l0.963,0.556L259.074,254.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M256.705,253.362c-1.392,0.802-2.682,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.75-3.208l26.987-15.545l0.963,0.556L256.705,253.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M254.337,251.995c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L254.337,251.995z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_139_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M251.968,250.627c-1.392,0.802-2.682,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.749-3.208l26.987-15.546l0.963,0.556L251.968,250.627z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M249.6,249.26c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.749-3.208l26.986-15.545l0.963,0.556L249.6,249.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_137_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M247.231,247.892c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.75-3.208l26.986-15.546l0.963,0.556L247.231,247.892z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M244.863,246.525c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.546l0.963,0.556L244.863,246.525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M242.494,245.158c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L242.494,245.158z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M240.126,243.79c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L240.126,243.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M237.757,242.423c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.407,3.75-3.208l26.987-15.545l0.963,0.556L237.757,242.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M235.389,241.055c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.75-3.208l26.987-15.546l0.963,0.556L235.389,241.055z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M233.02,239.688c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.987-15.545l0.963,0.556L233.02,239.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M230.652,238.32c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.986-15.546l0.963,0.556L230.652,238.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M228.283,236.953c-1.392,0.802-2.681,1.971-3.749,3.208l-0.963-0.556 c1.068-1.237,2.357-2.406,3.749-3.208l26.986-15.545l0.963,0.556L228.283,236.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M258.368,260.214l0.385-0.445c1.215-1.407,2.555-2.552,3.876-3.312l27.228-15.686 l1.937,1.118l-27.717,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.305L258.368,260.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M256.023,258.816l0.385-0.445c1.215-1.407,2.555-2.551,3.875-3.312l27.228-15.686 l1.937,1.118l-27.716,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.305L256.023,258.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M253.678,257.418l0.385-0.445c1.215-1.407,2.555-2.551,3.876-3.312l27.228-15.686 l1.937,1.118l-27.717,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.304L253.678,257.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M239.49,249.172l0.385-0.445c1.215-1.407,2.555-2.552,3.875-3.312l27.228-15.686 l1.937,1.118l-27.717,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.305L239.49,249.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M237.145,247.774l0.385-0.445c1.215-1.407,2.555-2.551,3.876-3.312l27.228-15.686 l1.937,1.118l-27.717,15.966c-1.229,0.707-2.482,1.781-3.625,3.105l-0.263,0.304L237.145,247.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#b8a7fc"
    },
    d: "M234.799,246.376l0.385-0.445c1.215-1.407,2.555-2.552,3.875-3.312l27.228-15.686 l1.937,1.118l-27.717,15.966c-1.228,0.707-2.482,1.781-3.625,3.105l-0.263,0.304L234.799,246.376z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_145_",
    style: {
      fill: "#E6E6E6"
    },
    points: "294.306,249.259 300.618,245.931 300.622,245.413  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_142_",
    style: {
      fill: "#E6E6E6"
    },
    points: "300.624,247.786 290.097,253.671 300.624,247.403  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    style: {
      opacity: 0.02
    },
    d: "M192.021,247.287c5.689-3.005,13.311-6.748,17.327-7.525 c3.247-0.627,5.239-0.189,6.451,0.499l0.005-0.009l46.01,26.564c-1.041-0.601-2.55-0.922-4.678-0.678 c0,0-22.775-13.891-37.48-18.635C204.952,242.76,192.021,247.287,192.021,247.287z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M160.081,140.162c-8.682,0.49-18.937,5.596-20.371,18.253c-1.21,10.682,0.025,46.48,0.746,54.677 c0.868,9.873,1.059,12.771,7.1,17.62c8.73,7.007,37.24,29.951,48.866,34.517c7.183,2.82,14.173,4.969,20.028,4.277l-16.715-9.64 c0,0,6.134-0.398,10.672-1.398c4.537-1,2.583-4.526-2.171-4.382c-3.869,0.117-10.068-4.583-19.536-5.014l5.355-2.847 l-31.297-30.535c0,0,0.166-51.676-0.755-48.19C161.927,167.787,160.081,140.162,160.081,140.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M161.09,138.887c0,0-6.511-0.184-10.75,1.625c-6.874,2.933-11.206,10.878-11.824,21.333 c-0.477,8.078,0,35.761,0,35.761s11.61,4.289,24.408-0.87c0.113-0.989,0.982-30.212,0.982-30.212S169.09,148.193,161.09,138.887z "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_542_",
    style: {
      opacity: 0.2
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_543_",
    d: "M365.726,264.81l-43.028,24.842c-0.669,0.386-1.754,0.386-2.423,0l-31.665-18.282 c-0.669-0.386-0.669-1.013,0-1.399l43.028-24.842c0.669-0.386,1.754-0.386,2.422,0l31.665,18.282 C366.395,263.797,366.395,264.424,365.726,264.81z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_540_",
    style: {
      opacity: 0.2
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_541_",
    d: "M365.726,269.248l-43.028,24.842c-0.669,0.386-1.754,0.386-2.423,0l-31.665-18.282 c-0.669-0.386-0.669-1.013,0-1.399l43.028-24.842c0.669-0.386,1.754-0.386,2.422,0l31.665,18.282 C366.395,268.236,366.395,268.862,365.726,269.248z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_533_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_538_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_539_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M365.726,267.029l-43.028,24.842c-0.669,0.386-1.754,0.386-2.423,0 l-31.665-18.282c-0.669-0.386-0.669-1.012,0-1.399l43.028-24.842c0.669-0.386,1.754-0.386,2.423,0l31.665,18.282 C366.395,266.016,366.395,266.643,365.726,267.029z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_536_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_537_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M334.061,247.348l30.069,17.36l-41.432,23.921c-0.669,0.386-1.754,0.386-2.423,0 l-30.069-17.36l41.432-23.921C332.307,246.962,333.392,246.962,334.061,247.348z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_534_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_535_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M365.726,262.655l-43.028,24.842c-0.669,0.386-1.754,0.386-2.423,0 l-31.665-18.282c-0.669-0.386-0.669-1.012,0-1.399l43.028-24.842c0.669-0.386,1.754-0.386,2.422,0l31.665,18.282 C366.395,261.642,366.395,262.268,365.726,262.655z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Pencil"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pencil_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_8_",
    style: {
      opacity: 0.2
    },
    d: "M310.14,236.648c-1.371,0.699,2.094,3.14,3.808,2.198l30.032-17.585l3.605-3.804 c0.169-0.179-0.008-0.466-0.244-0.394l-6.955,2.123L310.14,236.648z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_522_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_524_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_532_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M340.662,216.51l6.398-1.253c0.186-0.036,0.313,0.184,0.187,0.326l-4.341,4.915 L340.662,216.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_531_",
    style: {
      fill: "#263238"
    },
    d: "M347.247,215.583c0.126-0.142-0.001-0.362-0.187-0.326l-1.249,0.245l0,0 c0.35,0.217,0.549,0.611,0.516,1.021l-0.009,0.111L347.247,215.583z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_530_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M319.048,234.181l0.523-0.301l0.633-0.36l22.702-13.021 c0.237-0.695,0.122-1.456-0.178-2.122c-0.454-1.016-1.335-1.817-2.065-1.864l-22.688,13.014l-1.207,0.693 C317.574,229.814,319.851,233.763,319.048,234.181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M321.044,233.044l1.168-0.673c0.345-0.184,0.147-1.031-0.256-1.907 c-0.533-1.165-1.583-2.293-2.041-2.05l-0.862,0.494l-0.305,0.182c0.458-0.243,1.509,0.885,2.042,2.05 c0.386,0.84,0.581,1.657,0.289,1.879l-0.004,0.002C321.068,233.032,321.057,233.038,321.044,233.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_528_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M321.334,232.874c0.802-0.425-1.494-4.38-2.296-3.954l-1.171,0.67 c0.802-0.425,3.098,3.529,2.296,3.954L321.334,232.874z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_527_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M319.048,234.181l1.156-0.661c0.79-0.411-1.393-4.246-2.229-3.993 c-0.015,0.003-0.031,0.011-0.048,0.018l-1.16,0.674C317.574,229.814,319.851,233.763,319.048,234.181z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_526_",
    style: {
      opacity: 0.15
    },
    d: "M347.277,215.367l-0.216-0.111l-4.643,2.539l-24.006,13.774 c-0.045-0.072-0.082-0.076-0.112-0.027c0.682,1.064,1.198,2.403,0.748,2.637l0.523-0.301l0.633-0.36l22.702-13.021l0-0.001 l4.341-4.915C347.306,215.516,347.308,215.434,347.277,215.367z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_525_",
    style: {
      fill: "#F28F8F"
    },
    d: "M314.143,236.987l4.905-2.806c0.344-0.178,0.153-1.017-0.243-1.889 c-0.53-1.167-1.576-2.305-2.037-2.072c-0.003-0.001-0.003-0.001-0.006,0.001l-4.92,2.817c-0.977,0.564-0.078,2.686,1.012,3.635 C313.259,237.03,313.712,237.189,314.143,236.987z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_523_",
    style: {
      opacity: 0.1
    },
    d: "M314.436,235.466c-0.281-1.106-1.177-2.189-2-2.421 c-0.302-0.085-0.552-0.042-0.734,0.099c-0.738,0.685,0.121,2.632,1.152,3.529c0.397,0.351,0.841,0.508,1.264,0.323 C314.485,236.781,314.627,236.215,314.436,235.466z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lamp_2_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_7_",
    style: {
      opacity: 0.2
    },
    cx: 381.949,
    cy: 246.667,
    rx: 20.294,
    ry: 11.237
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_503_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_518_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_521_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M369.366,183.832c-2.267,8.649-10.027,11.48-17.332,6.324 c-7.305-5.156-11.388-16.348-9.121-24.997c2.267-8.649,10.027-11.48,17.332-6.324 C367.55,163.992,371.634,175.183,369.366,183.832z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_520_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M377.354,159.804l2.254,6.141l2.254,6.14c-2.575,6.778-8.423,16.103-19.238,20.073 l-12.968-35.324C360.472,152.863,371.005,156.302,377.354,159.804z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_519_",
    style: {
      opacity: 0.25
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M374.449,158.454c0,0-5.645,6.414-2.635,13.214c0,0-3.957-4.771-3.052-9.272 C369.668,157.894,374.449,158.454,374.449,158.454z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_517_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M373.298,158.83c6.306-2.265,12.022-0.944,12.022-0.944l1.785,4.97l0.197,0.548l1.785,4.971 c0,0-3.558,4.64-9.845,6.909c-0.006,0.002-0.012,0.005-0.018,0.007c-0.004,0.002-0.008,0.004-0.012,0.005l-0.001-0.001 c-1.456,0.519-3.198,0.242-4.886-0.956c-3.389-2.407-5.273-7.616-4.208-11.634c0.535-2.017,1.712-3.35,3.18-3.873 L373.298,158.83z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_516_",
    style: {
      opacity: 0.15
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M373.298,158.83c6.306-2.265,12.022-0.944,12.022-0.944l1.785,4.97l0.197,0.548l1.785,4.971 c0,0-3.558,4.64-9.845,6.909c-0.006,0.002-0.012,0.005-0.018,0.007c-0.004,0.002-0.008,0.004-0.012,0.005l-0.001-0.001 c-1.456,0.519-3.198,0.242-4.886-0.956c-3.389-2.407-5.273-7.616-4.208-11.634c0.535-2.017,1.712-3.35,3.18-3.873 L373.298,158.83z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M349.657,156.835l-0.001-0.002c0.006-0.002,0.012-0.004,0.019-0.006 c0.022-0.008,0.045-0.014,0.068-0.022c9.335-3.394,18.447-1.282,24.836,1.612c5.779-1.676,10.741-0.532,10.741-0.532 l1.785,4.97l0.197,0.548l1.785,4.971c0,0-2.988,3.883-8.314,6.281c-2.983,6.395-8.648,14.014-18.149,17.502l-0.001-0.002 c-3.144,1.161-6.923,0.588-10.589-2c-7.304-5.156-11.388-16.348-9.121-24.996C344.043,160.851,346.537,157.988,349.657,156.835 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_515_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M390.243,166.38c-0.705,2.658-3.094,3.522-5.336,1.93c-2.242-1.592-3.488-5.037-2.783-7.695 c0.705-2.658,3.094-3.522,5.336-1.93C389.702,160.276,390.948,163.722,390.243,166.38z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_513_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M381.79,172.075c0.682-1.063,2.258-1.877,3.519-1.818c0.675,0.032,1.114,0.311,1.281,0.723 l0.009-0.005l13.896,28.992l-0.011,0.005c0.133,0.354,0.071,0.801-0.239,1.285c-0.682,1.063-2.258,1.877-3.52,1.818 c-0.677-0.032-1.117-0.313-1.282-0.727l-0.009,0.005l-13.872-28.935l0.007-0.003 C381.408,173.052,381.465,172.583,381.79,172.075z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_512_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M365.87,244.622c-0.012-0.451,0.035-0.901,0.13-1.349c0.806-5.048,5.168-10.503,8.21-12.24 h17.156c3.041,1.737,7.402,7.189,8.209,12.236c0.096,0.45,0.143,0.901,0.131,1.354c0.002,0.076-0.019,0.228-0.019,0.228 c-0.159,2.373-1.789,4.72-4.928,6.532c-6.612,3.817-17.332,3.817-23.944,0c-3.138-1.812-4.768-4.159-4.927-6.532 C365.889,244.851,365.868,244.698,365.87,244.622z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_511_",
    style: {
      opacity: 0.15
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M365.87,244.622c-0.012-0.451,0.035-0.901,0.13-1.349c0.806-5.048,5.168-10.503,8.21-12.24h17.156 c3.041,1.737,7.402,7.189,8.209,12.236c0.096,0.45,0.143,0.901,0.131,1.354c0.002,0.076-0.019,0.228-0.019,0.228 c-0.159,2.373-1.789,4.72-4.928,6.532c-6.612,3.817-17.332,3.817-23.944,0c-3.138-1.812-4.768-4.159-4.927-6.532 C365.889,244.851,365.868,244.698,365.87,244.622z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_510_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M390.926,230.757c4.494,2.594,4.494,6.801,0,9.396c-4.494,2.594-11.78,2.594-16.274,0 c-4.494-2.595-4.494-6.801,0-9.396C379.146,228.163,386.432,228.163,390.926,230.757z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_508_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M384.924,233.519c1.251,0.722,1.251,1.894,0,2.616c-1.251,0.723-3.28,0.723-4.531,0 c-1.251-0.722-1.251-1.894,0-2.616C381.644,232.796,383.673,232.796,384.924,233.519z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_507_"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#37474F"
    },
    points: "393.808,203.215 379.842,233.915 385.491,235.718 399.069,205.976  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_506_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M399.5,195.807l0.005,0.015c0.801-0.266,1.756,0.016,2.662,0.929 c1.729,1.745,2.608,5.08,1.962,7.451c-0.292,1.069-0.85,1.736-1.526,2.011l0.007,0.023l-5.887,2.205l-2.927-10.488 L399.5,195.807z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_505_",
    style: {
      opacity: 0.15
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5,195.807l0.005,0.015c0.801-0.266,1.756,0.016,2.662,0.929c1.729,1.745,2.608,5.08,1.962,7.451 c-0.292,1.069-0.85,1.736-1.526,2.011l0.007,0.023l-5.887,2.205l-2.927-10.488L399.5,195.807z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_504_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M396.369,198.923c1.73,1.745,2.608,5.08,1.962,7.451c-0.646,2.37-2.572,2.877-4.301,1.133 c-1.73-1.745-2.608-5.08-1.962-7.451C392.713,197.686,394.639,197.179,396.369,198.923z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Backpack_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backpack_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M100.954,276.947c-6.545-0.491-21.906,8.373-24.502,13.337 c-2.724,5.208-15.624,77.117-10.44,84.212c6.507,8.904,39.997,27.561,55.129,27.967c12.483,0.335,25.003-10.405,27.097-13.626 c3.43-5.277,3.885-80.033,0.298-86.543C142.723,291.745,109.293,277.573,100.954,276.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M100.954,276.947c-6.545-0.491-21.906,8.373-24.502,13.337 c-2.724,5.208-15.624,77.117-10.44,84.212c6.507,8.904,39.997,27.561,55.129,27.967c12.483,0.335,25.003-10.405,27.097-13.626 c3.43-5.277,3.885-80.033,0.298-86.543C142.723,291.745,109.293,277.573,100.954,276.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M151.022,340.367c-0.011-3.131-0.044-6.227-0.099-9.221c-0.022-1.198-0.048-2.379-0.077-3.54 c-0.059-2.322-0.131-4.563-0.219-6.688c-0.044-1.063-0.091-2.096-0.142-3.097c-0.077-1.501-0.161-2.928-0.255-4.266 c-0.094-1.338-0.195-2.588-0.305-3.736c-0.037-0.382-0.074-0.753-0.113-1.112c-0.347-3.232-0.772-5.497-1.276-6.412 c-0.165-0.298-0.358-0.6-0.565-0.903c-0.068-0.1-0.143-0.2-0.216-0.3c-0.148-0.205-0.305-0.41-0.471-0.617 c-0.097-0.121-0.195-0.241-0.298-0.362c-0.164-0.193-0.34-0.388-0.519-0.582c-0.113-0.123-0.22-0.245-0.339-0.369 c-0.267-0.279-0.551-0.558-0.845-0.839c-0.19-0.181-0.393-0.362-0.594-0.544c-0.134-0.121-0.267-0.242-0.405-0.363 c-0.226-0.197-0.458-0.395-0.695-0.593c-0.116-0.097-0.235-0.194-0.353-0.29c-0.264-0.215-0.53-0.431-0.808-0.647 c-6.022,2.104-11.719,4.104-11.892,4.203c-0.369,0.213-6.562,3.461-6.807,12.626l-2.128,37.027l-0.211,3.518 c-0.203,4.912-7.081,49.967,6.943,48.171c0.182-0.023,0.373-0.041,0.556-0.063c9.516-2.759,17.691-9.984,19.346-12.53 c0.268-0.412,0.518-1.248,0.749-2.443c0.092-0.478,0.182-1.013,0.268-1.601c0.043-0.294,0.086-0.602,0.128-0.922 c0.125-0.961,0.243-2.036,0.355-3.212c0.037-0.392,0.074-0.795,0.109-1.209c0.534-6.209,0.893-14.815,1.064-24.047 c0.034-1.846,0.061-3.718,0.08-5.6c0.013-1.255,0.022-2.514,0.028-3.774c0.003-0.63,0.005-1.26,0.006-1.89 C151.027,342.878,151.027,341.619,151.022,340.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M149.537,306.479c-0.29-2.045-0.622-3.499-1.001-4.186c-5.813-10.549-39.243-24.721-47.583-25.346 c-6.545-0.491-21.906,8.373-24.502,13.337c-0.422,0.806-1.078,3.155-1.867,6.571c12.69,7.709,45.597,25.111,49.147,24.05 c4.362-1.304,25.395-13.83,25.799-14.408L149.537,306.479z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M106.116,361.762c-6.759-3.651-21.707-13.321-25.88-15.547c-1.967-1.05-3.636-0.964-4.755-0.277 c-0.637,0.391-2.844,1.78-3.416,2.099c-0.954,0.532-1.541,1.485-1.616,2.564c-0.548,7.823-0.908,11.042-0.784,14.827 c0.085,2.59,0.422,4.906,4.05,7.845c3.628,2.939,19.441,12.555,24.139,15.152c4.425,2.446,9.183,4.34,11.223,2.988 c0.53-0.351,2.926-1.744,3.554-2.159c0.607-0.4,0.972-1.089,1.014-2.138c0.16-4.007,0.772-12.548,0.961-15.457 C114.839,368.061,113.242,365.613,106.116,361.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M106.116,361.762c-6.759-3.651-21.707-13.321-25.88-15.547c-1.967-1.05-3.636-0.964-4.755-0.277 c-0.637,0.391-2.844,1.78-3.416,2.099c-0.954,0.532-1.541,1.485-1.616,2.564c-0.548,7.823-0.908,11.042-0.784,14.827 c0.085,2.59,0.422,4.906,4.05,7.845c3.628,2.939,19.441,12.555,24.139,15.152c4.425,2.446,9.183,4.34,11.223,2.988 c0.53-0.351,2.926-1.744,3.554-2.159c0.607-0.4,0.972-1.089,1.014-2.138c0.16-4.007,0.772-12.548,0.961-15.457 C114.839,368.061,113.242,365.613,106.116,361.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M110.56,370.531l3.607-2.002c-0.879-2.145-3.165-4.126-8.052-6.766 c-6.759-3.651-21.707-13.321-25.88-15.547c-1.967-1.05-3.636-0.964-4.755-0.277c-0.638,0.391-2.844,1.78-3.416,2.099 c-0.715,0.399-1.223,1.034-1.465,1.781L110.56,370.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M70.449,350.602c-0.548,7.823-0.908,11.042-0.784,14.827c0.085,2.59,0.422,4.906,4.05,7.845 c3.627,2.939,19.441,12.555,24.139,15.152c5.747,3.177,12.076,5.443,12.26,0.855c0.16-4.007,0.772-12.548,0.961-15.457 c0.233-3.599-1.363-6.048-8.49-9.898c-6.759-3.652-21.707-13.321-25.879-15.547C73.179,346.498,70.613,348.26,70.449,350.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    d: "M70.449,350.602c-0.548,7.823-0.908,11.042-0.784,14.827c0.085,2.59,0.422,4.906,4.05,7.845 c3.627,2.939,19.441,12.555,24.139,15.152c5.747,3.177,12.076,5.443,12.26,0.855c0.16-4.007,0.772-12.548,0.961-15.457 c0.233-3.599-1.363-6.048-8.49-9.898c-6.759-3.652-21.707-13.321-25.879-15.547C73.179,346.498,70.613,348.26,70.449,350.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M114.167,368.529c-0.696-2.069-4.127-0.708-4.934,2.002c-0.807,2.711-0.796,6.337-1.187,7.511 c-0.392,1.175-37.396-20.872-38.406-22.124c-0.465-0.577,0.114-7.161,1.485-8.332c1.371-1.171,4.504-3.223,6.56-2.784 s24.508,13.986,28.898,16.366C110.971,363.549,114.426,365.97,114.167,368.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M114.167,368.529c-0.696-2.069-4.127-0.708-4.934,2.002c-0.807,2.711-0.796,6.337-1.187,7.511 c-0.392,1.175-37.396-20.872-38.406-22.124c-0.465-0.577,0.114-7.161,1.485-8.332c1.371-1.171,4.504-3.223,6.56-2.784 s24.508,13.986,28.898,16.366C110.971,363.549,114.426,365.97,114.167,368.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M96.581,375.41l4.467,2.439c0.537,0.293,1.098,0.048,1.247-0.546l0.567-2.265 c0.123-0.49-0.137-1.093-0.578-1.34l-4.48-2.515c-0.531-0.298-1.084-0.058-1.229,0.533l-0.58,2.367 C95.876,374.572,96.139,375.169,96.581,375.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M74.524,362.216l4.467,2.439c0.537,0.293,1.098,0.047,1.247-0.546l0.567-2.265 c0.123-0.49-0.137-1.093-0.577-1.34l-4.48-2.515c-0.531-0.298-1.084-0.058-1.229,0.533l-0.58,2.367 C73.82,361.377,74.083,361.975,74.524,362.216z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M68.533,329.98c0.87-5.683,1.377-9.564,2.334-14.325c1.848-1.309,4.415-2.942,4.415-2.942 c5.324,1.872,10.648,3.745,15.972,5.617c4.981,1.752,9.962,3.504,14.943,5.255c1.132,0.398,2.263,0.796,3.395,1.194 c1.059,0.372,2.131,1.042,3.186,1.33c2.728,0.743,6.798-1.466,8.882-3.037c2.083-1.571,3.351-3.064,5.978-3.624 c-0.374,5.17-0.788,10.337-1.243,15.501c-0.428,4.859-0.507,9.788-2.181,14.391c-1.026,2.435-2.659,4.193-5.245,4.823 c-2.847,0.693-5.883,0.41-8.739-0.081c0,0-0.423,4.355-0.911,6.509c-0.699,1.904-3.467,3.46-3.874,3.353 c-2.522-0.663-2.521-12.477-2.521-12.477l-18.957-10.285c0,0-0.68,4.244-1.29,6.311c-1.063,1.641-3.092,3.443-3.831,3.255 c-3.182-0.814-1.793-13.521-1.793-13.521S71.346,334.048,68.533,329.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M100.276,276.905c-7.192-0.447-20.387,6.121-24.39,11.559c-4.002,5.438-9.326,32.835-6.949,37.846 c2.339,4.931,21.89,16.533,33.737,22.248c9.467,4.567,14.412,3.497,18.202,1.616c2.853-1.416,2.954-6.052,3.333-9.489 c0.973-8.841,2.237-24.705,7.908-29.576c5.672-4.872,16.039-8.634,17.413-4.61c0,0,1.948-5.804-8.75-12.186 C123.046,283.733,109.129,277.456,100.276,276.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M100.276,276.905c-7.192-0.447-20.387,6.121-24.39,11.559c-4.002,5.438-9.326,32.835-6.949,37.846 c2.339,4.931,21.89,16.533,33.737,22.248c9.467,4.567,14.412,3.497,18.202,1.616c2.853-1.416,2.954-6.052,3.333-9.489 c0.973-8.841,2.237-24.705,7.908-29.576c5.672-4.872,16.039-8.634,17.413-4.61c0,0,1.948-5.804-8.75-12.186 C123.046,283.733,109.129,277.456,100.276,276.905z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M103.968,333.566l6.262,2.838c0,0-1.997,15.519-2.452,23.171c0,0-1.7,3.202-3.133,3.655 c-1.433,0.453-3.03-3.349-3.164-6.133C101.348,354.314,102.878,340.148,103.968,333.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M103.689,335.071l6.382,2.667c0.768,0.321,1.492-0.091,1.609-0.914l0.448-3.141 c0.097-0.68-0.34-1.458-0.97-1.73l-6.411-2.768c-0.76-0.328-1.474,0.074-1.586,0.894l-0.45,3.282 C102.618,334.038,103.058,334.808,103.689,335.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M104.802,354.032c0.964,0.462,1.689,1.732,1.62,2.836c-0.068,1.104-0.907,1.648-1.873,1.217 c-0.966-0.432-1.691-1.701-1.62-2.836C103,354.114,103.839,353.569,104.802,354.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M78.107,320.53l6.107,3.158c0,0-1.807,15.334-2.657,22.951c0,0-1.863,3.11-3.317,3.488 c-1.454,0.379-2.853-3.501-2.843-6.288C75.408,341.052,76.678,327.047,78.107,320.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M77.751,322.019l6.236,2.993c0.75,0.36,1.494-0.014,1.654-0.83l0.609-3.114 c0.132-0.674-0.264-1.474-0.879-1.778l-6.259-3.096c-0.742-0.367-1.476-0.002-1.631,0.812l-0.619,3.254 C76.735,320.931,77.134,321.723,77.751,322.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M78.872,340.95c0.938,0.512,1.597,1.817,1.472,2.916c-0.126,1.099-0.991,1.599-1.933,1.118 c-0.942-0.481-1.601-1.786-1.472-2.916C77.068,340.939,77.934,340.438,78.872,340.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M152.898,355.219c-0.381-0.22-5.885-4.832-6.533-5.206c-1.142-0.659-18.781,9.943-20.46,11.813 c-1.168,1.301-0.588,22.425-0.001,23.96c0.212,0.552,6.323,4.656,6.533,5.206c0.587,1.536,19.187-9.206,20.46-11.98 C154.17,376.237,154.576,356.186,152.898,355.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    d: "M152.898,355.219c-0.381-0.22-5.885-4.832-6.533-5.206c-1.142-0.659-18.781,9.943-20.46,11.813 c-1.168,1.301-0.588,22.425-0.001,23.96c0.212,0.552,6.323,4.656,6.533,5.206c0.587,1.536,19.187-9.206,20.46-11.98 C154.17,376.237,154.576,356.186,152.898,355.219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M132.438,367.032c-1.168,1.301-0.589,22.425-0.001,23.96c0.588,1.536,19.187-9.206,20.46-11.98 c1.272-2.774,1.679-22.825,0.001-23.793C151.756,354.56,134.117,365.161,132.438,367.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M146.369,350.017c0.642,0.365,6.145,4.986,6.523,5.201c-1.133-0.655-18.775,9.948-20.45,11.811 l-6.535-5.201C127.582,359.952,145.223,349.349,146.369,350.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M132.438,367.032c-1.168,1.301-0.589,22.425-0.001,23.96c0.588,1.536,19.187-9.206,20.46-11.98 c1.272-2.774,1.679-22.825,0.001-23.793C151.756,354.56,134.117,365.161,132.438,367.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M125.907,361.828c1.307-0.759,4.992,1.459,6.554,2.951s2.989,8.181,7.158,9.447 c4.169,1.266,10.421-4.005,11.86-7.517c1.439-3.512,3.318-10.951,1.413-13.741c-1.905-2.791-5.398-4.437-8.472-2.98 C141.347,351.444,126.442,358.554,125.907,361.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M125.907,361.828c1.307-0.759,4.992,1.459,6.554,2.951s2.989,8.181,7.158,9.447 c4.169,1.266,10.421-4.005,11.86-7.517c1.439-3.512,3.318-10.951,1.413-13.741c-1.905-2.791-5.398-4.437-8.472-2.98 C141.347,351.444,126.442,358.554,125.907,361.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M144.77,365.737c-0.964,0.463-1.689,1.732-1.62,2.836c0.069,1.104,0.907,1.648,1.873,1.217 c0.966-0.431,1.691-1.701,1.62-2.836C146.572,365.819,145.734,365.275,144.77,365.737z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Books_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Books"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Book_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5431_"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5436_",
    points: "249.879,431.98 211.825,453.674 148.959,417.596 187.009,395.9  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5435_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M211.391,452.025l36.708-21.066c-0.959-2.721-0.887-5.897,0.198-9.52 l-36.473,20.843C211.824,442.282,211.127,444.581,211.391,452.025z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5434_",
    style: {
      fill: "#263238"
    },
    d: "M213.697,439.308c-1.948,1.118-3.527,3.837-3.527,6.072v7.094 c0,2.236,1.579,3.142,3.527,2.024l36.177-20.761l0.004-1.758l-35.694,20.355c-1.169,0.671-2.115,0.127-2.114-1.215l0.033-6.574 c0.001-1.342,0.95-2.973,2.118-3.644l35.652-20.364v-1.992L213.697,439.308z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5433_",
    style: {
      fill: "#455A64"
    },
    d: "M249.874,418.55l-62.866-36.078l-36.174,20.76 c-1.947,1.117-3.527,3.838-3.527,6.072l-0.002,7.095c0.002,1.114,0.393,1.899,1.035,2.267l62.867,36.078 c-0.642-0.368-1.032-1.153-1.035-2.267l-0.005-7.099c0-2.234,1.58-4.955,3.527-6.072L249.874,418.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5432_",
    style: {
      fill: "#37474F"
    },
    d: "M211.2,441.923c-0.638,1.099-1.033,2.338-1.033,3.455l0.005,7.099 c0.002,1.114,0.393,1.899,1.035,2.267l-62.867-36.078c-0.642-0.368-1.033-1.153-1.035-2.267l0.002-7.095 c0-1.117,0.395-2.356,1.033-3.455L211.2,441.923z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Book_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5463_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5484_",
    style: {
      fill: "#E0E0E0"
    },
    points: "246.14,413.655 210.859,433.768 152.575,400.32 187.852,380.204  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5483_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M210.457,432.239l34.033-19.531c-0.889-2.523-0.822-5.467,0.184-8.826 l-33.815,19.324C210.859,423.206,210.213,425.337,210.457,432.239z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5482_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M212.595,420.449c-1.806,1.036-3.27,3.557-3.27,5.63l0,6.577 c0,2.073,1.464,2.913,3.27,1.877l33.541-19.249l0.004-1.63l-33.093,18.871c-1.084,0.622-1.961,0.118-1.96-1.126l0.031-6.095 c0.001-1.244,0.88-2.756,1.964-3.378l33.054-18.88V401.2L212.595,420.449z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5481_",
    style: {
      opacity: 0.35
    },
    d: "M212.595,420.449c-1.806,1.036-3.27,3.557-3.27,5.63l0,6.577 c0,2.073,1.464,2.913,3.27,1.877l33.541-19.249l0.004-1.63l-33.093,18.871c-1.084,0.622-1.961,0.118-1.96-1.126l0.031-6.095 c0.001-1.244,0.88-2.756,1.964-3.378l33.054-18.88V401.2L212.595,420.449z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5480_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M246.136,401.204l-58.285-33.449l-33.538,19.247 c-1.805,1.036-3.27,3.558-3.27,5.63l-0.001,6.578c0.002,1.033,0.364,1.76,0.959,2.102l58.285,33.449 c-0.595-0.342-0.957-1.069-0.959-2.102l-0.005-6.582c0-2.072,1.465-4.594,3.27-5.63L246.136,401.204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5466_",
    style: {
      opacity: 0.15
    },
    d: "M246.136,401.204l-58.285-33.449l-33.538,19.247 c-1.805,1.036-3.27,3.558-3.27,5.63l-0.001,6.578c0.002,1.033,0.364,1.76,0.959,2.102l58.285,33.449 c-0.595-0.342-0.957-1.069-0.959-2.102l-0.005-6.582c0-2.072,1.465-4.594,3.27-5.63L246.136,401.204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5465_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M210.28,422.874c-0.592,1.019-0.958,2.167-0.958,3.203l0.005,6.582 c0.002,1.033,0.364,1.76,0.959,2.102l-58.285-33.449c-0.595-0.342-0.957-1.069-0.959-2.102l0.001-6.578 c0-1.036,0.366-2.184,0.958-3.203L210.28,422.874z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5464_",
    style: {
      opacity: 0.25
    },
    d: "M210.28,422.874c-0.592,1.019-0.958,2.167-0.958,3.203l0.005,6.582 c0.002,1.033,0.364,1.76,0.959,2.102l-58.285-33.449c-0.595-0.342-0.957-1.069-0.959-2.102l0.001-6.578 c0-1.036,0.366-2.184,0.958-3.203L210.28,422.874z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facebook_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5501_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5502_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5503_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5515_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M241.267,103.089c-0.313-0.181-0.746-0.156-1.224,0.121 c-0.956,0.552-1.731,1.895-1.731,2.999c0,0.554,0.195,0.942,0.511,1.122c0.082,0.047,1.441,0.838,1.523,0.886 c0.313,0.181,0.746,0.155,1.224-0.121c0.956-0.552,1.731-1.895,1.731-2.999c0-0.552-0.194-0.939-0.507-1.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5514_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M241.569,104.097c-0.956,0.552-1.731,1.895-1.731,2.999 c0,1.104,0.775,1.552,1.731,0.999c0.956-0.552,1.732-1.895,1.731-2.999C243.299,103.993,242.524,103.545,241.569,104.097z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5510_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M241.267,103.089l1.527,0.888 c-0.313-0.181-0.746-0.156-1.224,0.121c-0.626,0.362-1.174,1.062-1.479,1.813l-1.527-0.888 c0.304-0.751,0.852-1.451,1.479-1.813C240.521,102.934,240.954,102.908,241.267,103.089z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5508_",
    style: {
      opacity: 0.2
    },
    d: "M240.322,108.203c-0.108-0.062-1.424-0.829-1.5-0.873 c-0.315-0.18-0.511-0.568-0.511-1.122l1.527,0.888C239.838,107.634,240.023,108.017,240.322,108.203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5506_",
    style: {
      opacity: 0.1
    },
    d: "M238.564,105.022l1.527,0.888c-0.16,0.396-0.253,0.805-0.253,1.186v0 l-1.527-0.888C238.311,105.827,238.404,105.418,238.564,105.022z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Facebook_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5489_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5490_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5491_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5500_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M255.063,99.335c-0.495-0.286-1.179-0.246-1.935,0.191 c-1.511,0.872-2.735,2.994-2.735,4.738c0,0.875,0.309,1.489,0.807,1.773c0.13,0.074,1.643,0.95,1.774,1.025 c0.495,0.286,1.179,0.245,1.934-0.191c1.511-0.872,2.735-2.994,2.735-4.738c0-0.872-0.306-1.484-0.801-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5499_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M254.907,100.554c-1.51,0.873-2.735,2.994-2.735,4.738 c0,1.745,1.225,2.452,2.736,1.579c1.511-0.872,2.737-2.994,2.735-4.738C257.641,100.389,256.416,99.682,254.907,100.554z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5497_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M255.063,99.335l1.779,1.029 c-0.495-0.287-1.179-0.246-1.935,0.19c-0.989,0.572-1.856,1.679-2.336,2.865l-1.779-1.029c0.48-1.186,1.346-2.293,2.336-2.864 C253.884,99.089,254.568,99.048,255.063,99.335z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5495_",
    style: {
      opacity: 0.2
    },
    d: "M252.937,107.041c-0.171-0.099-1.618-0.936-1.737-1.004 c-0.498-0.284-0.807-0.898-0.807-1.773l1.779,1.029C252.173,106.143,252.464,106.747,252.937,107.041z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5492_",
    style: {
      opacity: 0.1
    },
    d: "M250.792,102.39l1.779,1.029c-0.254,0.625-0.399,1.272-0.399,1.874v0.001 l-1.779-1.029C250.393,103.662,250.539,103.015,250.792,102.39z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Facebook_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5258_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5260_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5262_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5486_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M268.078,88.5c-0.68-0.394-1.62-0.338-2.658,0.262 c-2.075,1.198-3.758,4.112-3.757,6.509c0,1.202,0.424,2.046,1.108,2.436c0.178,0.102,1.591,0.919,1.771,1.023 c0.68,0.393,1.619,0.337,2.657-0.262c2.075-1.198,3.757-4.112,3.757-6.509c0-1.198-0.42-2.039-1.1-2.431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5485_",
    style: {
      fill: "#b8a7fc"
    },
    d: "M267.199,89.789c-2.075,1.199-3.758,4.112-3.757,6.509 s1.683,3.368,3.758,2.17c2.075-1.198,3.759-4.112,3.757-6.509C270.954,89.562,269.272,88.591,267.199,89.789z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5437_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M268.078,88.5l1.778,1.027c-0.68-0.394-1.62-0.338-2.658,0.262 c-1.359,0.785-2.549,2.306-3.209,3.935l-1.778-1.028c0.66-1.629,1.85-3.15,3.209-3.935 C266.459,88.162,267.398,88.106,268.078,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5285_",
    style: {
      opacity: 0.2
    },
    d: "M264.492,98.7c-0.235-0.135-1.556-0.9-1.721-0.994 c-0.685-0.39-1.109-1.233-1.109-2.436l1.778,1.028C263.442,97.466,263.842,98.296,264.492,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5278_",
    style: {
      opacity: 0.1
    },
    d: "M262.211,92.696l1.778,1.028c-0.348,0.859-0.548,1.747-0.548,2.574v0.001 l-1.778-1.028C261.663,94.443,261.864,93.554,262.211,92.696z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M306.813,19.752c-1.887-1.111-4.356-1.019-7.06,0.542c-0.49,0.283,2.487,2.462,2.015,2.82 c-0.264-1.897-1.043-3.258-2.155-3.944c-0.458-0.283-5.77-3.211-6.254-3.47c-1.175-0.628-2.688-0.542-4.338,0.411 c-1.832,1.058-3.721,2.345-4.941,4.625c0,0-3.45-1.896-3.885-2.149c-1.884-1.097-4.345-1-7.039,0.555 c-5.712,3.298-10.369,11.942-10.7,19.639c-1.41,0.231-2.907,0.782-4.461,1.679c-8.311,4.798-15.048,17.671-15.048,28.753 c0,5.876,1.895,10.067,4.914,11.993c0.522,0.333,6.003,3.333,6.486,3.601c2.622,1.449,6.015,1.277,9.721-0.862 c1.438-0.83,2.826-1.905,4.143-3.167c0.572,0.712,1.23,1.283,1.961,1.705c0.438,0.253,2.168,1.246,2.596,1.496 c2.249,1.314,5.185,1.205,8.403-0.652c4.275-2.468,8.059-7.446,10.388-13.08c1.674,0.472,3.662,0.168,5.801-1.067 c5.417-3.127,9.884-11.062,10.616-18.438c4.897-4.155,8.583-12.056,8.583-18.977c0-4.34-1.449-7.39-3.737-8.693 C312.392,22.824,307.237,20.001,306.813,19.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M306.813,19.752c-1.887-1.111-4.356-1.019-7.06,0.542 c-0.49,0.283,2.487,2.462,2.015,2.82c-0.264-1.897-1.043-3.258-2.155-3.944c-0.458-0.283-5.77-3.211-6.254-3.47 c-1.175-0.628-2.688-0.542-4.338,0.411c-1.832,1.058-3.721,2.345-4.941,4.625c0,0-3.45-1.896-3.885-2.149 c-1.884-1.097-4.345-1-7.039,0.555c-5.712,3.298-10.369,11.942-10.7,19.639c-1.41,0.231-2.907,0.782-4.461,1.679 c-8.311,4.798-15.048,17.671-15.048,28.753c0,5.876,1.895,10.067,4.914,11.993c0.522,0.333,6.003,3.333,6.486,3.601 c2.622,1.449,6.015,1.277,9.721-0.862c1.438-0.83,2.826-1.905,4.143-3.167c0.572,0.712,1.23,1.283,1.961,1.705 c0.438,0.253,2.168,1.246,2.596,1.496c2.249,1.314,5.185,1.205,8.403-0.652c4.275-2.468,8.059-7.446,10.388-13.08 c1.674,0.472,3.662,0.168,5.801-1.067c5.417-3.127,9.884-11.062,10.616-18.438c4.897-4.155,8.583-12.056,8.583-18.977 c0-4.34-1.449-7.39-3.737-8.693C312.392,22.824,307.237,20.001,306.813,19.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M272.258,29.949c-2.139,3.692-3.55,8.073-3.73,12.184l-6.071-3.351 c0.174-4.11,1.598-8.485,3.743-12.177L272.258,29.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M272.258,29.949c-2.139,3.692-3.55,8.073-3.73,12.184l-6.071-3.351 c0.174-4.11,1.598-8.485,3.743-12.177L272.258,29.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M263.196,33.935c-0.413,1.618-0.673,3.252-0.74,4.846l6.071,3.351 c0.07-1.593,0.329-3.226,0.739-4.844L263.196,33.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M254.018,84.617c-0.747-0.419-5.717-3.132-6.155-3.416c-3.022-1.92-4.916-6.114-4.916-11.99 c0-4.852,1.295-10.051,3.441-14.761l6.071,3.351c-2.152,4.71-3.441,9.909-3.441,14.767 C249.018,78.496,250.951,82.709,254.018,84.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M254.018,84.617c-0.747-0.419-5.717-3.132-6.155-3.416c-3.022-1.92-4.916-6.114-4.916-11.99 c0-4.852,1.295-10.051,3.441-14.761l6.071,3.351c-2.152,4.71-3.441,9.909-3.441,14.767 C249.018,78.496,250.951,82.709,254.018,84.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M247.863,81.201c0.438,0.283,5.408,2.997,6.155,3.416c-3.067-1.907-5-6.121-5-12.048 c0-0.533,0.022-1.07,0.052-1.61l-6.071-3.354c-0.03,0.538-0.052,1.075-0.052,1.606C242.947,75.087,244.841,79.281,247.863,81.201 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M272.489,83.818c-0.644-0.374-1.946-1.121-2.319-1.34c-0.728-0.419-1.385-0.992-1.959-1.701 c0.38-0.361,0.754-0.741,1.121-1.14C270.047,81.518,271.137,82.935,272.489,83.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M272.489,83.818c-0.644-0.374-1.946-1.121-2.319-1.34c-0.728-0.419-1.385-0.992-1.959-1.701 c0.38-0.361,0.754-0.741,1.121-1.14C270.047,81.518,271.137,82.935,272.489,83.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M316.558,31.762c0-7.903-4.805-11.536-10.733-8.114c-1.499,0.865-2.924,2.101-4.22,3.588 c0.17-0.891,0.267-1.781,0.267-2.647c0-4.992-3.035-7.287-6.78-5.125c-2.332,1.346-4.388,4.104-5.608,7.198 c-1.351-5.063-5.431-6.953-10.257-4.167c-5.713,3.298-10.369,11.942-10.701,19.639c-1.409,0.231-2.907,0.782-4.461,1.679 c-8.311,4.798-15.048,17.671-15.048,28.753s6.737,16.175,15.048,11.376c1.853-1.07,3.627-2.543,5.267-4.307 c1.931,5.063,6.503,6.768,11.836,3.689c4.275-2.468,8.059-7.446,10.388-13.08c1.674,0.472,3.662,0.168,5.801-1.067 c5.417-3.127,9.884-11.062,10.616-18.438C312.873,46.584,316.558,38.684,316.558,31.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M304.601,24.447c-1.05,0.767-2.062,1.714-2.996,2.79c0.174-0.889,0.271-1.778,0.271-2.648 c0-0.528-0.032-1.018-0.103-1.482c0.077-0.052,0.148-0.103,0.226-0.161L304.601,24.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M304.601,24.447c-1.05,0.767-2.062,1.714-2.996,2.79c0.174-0.889,0.271-1.778,0.271-2.648 c0-0.528-0.032-1.018-0.103-1.482c0.077-0.052,0.148-0.103,0.226-0.161L304.601,24.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8a7fc"
    },
    d: "M291.489,22.92c-0.786,1.128-1.482,2.403-2.004,3.743c-0.219-0.819-0.741-2.622-2.427-4.162 c-1.019-0.93-2.979-1.767-2.979-1.767c0.335-0.638,0.687-1.036,1.087-1.603L291.489,22.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M291.489,22.92c-0.786,1.128-1.482,2.403-2.004,3.743c-0.219-0.819-0.741-2.622-2.427-4.162 c-1.019-0.93-2.979-1.767-2.979-1.767c0.335-0.638,0.687-1.036,1.087-1.603L291.489,22.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5235_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M269.27,56.845c-1.635,0.945-2.961,3.241-2.961,5.129 c0,1.888,1.326,2.654,2.961,1.71c1.635-0.944,2.962-3.24,2.961-5.129C272.23,56.667,270.904,55.901,269.27,56.845z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5233_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M282.356,49.265c-1.635,0.945-2.961,3.24-2.961,5.129 c0,1.888,1.326,2.654,2.961,1.709c1.635-0.944,2.962-3.24,2.961-5.129C285.315,49.086,283.99,48.321,282.356,49.265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M295.442,41.719c-1.635,0.945-2.961,3.241-2.961,5.129 c0,1.888,1.326,2.654,2.961,1.71c1.635-0.944,2.962-3.24,2.961-5.129C298.401,41.541,297.076,40.776,295.442,41.719z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudying);
export default __webpack_public_path__ + "static/media/Studying.d0c1203e46e17a9e14babe2385d5511d.svg";
export { ForwardRef as ReactComponent };